webpackJsonp(["core"],{

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/process/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/global.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/module.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/firebase/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doLogEvent = doLogEvent;

var _app = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/firebase/app/dist/index.esm.js");

var _analytics = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/firebase/analytics/dist/index.esm.js");

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Initialize Firebase
// Import the functions you need from the SDKs you need
var app = (0, _app.initializeApp)(firebaseConfig);

var analytics = (0, _analytics.getAnalytics)(app);

function doLogEvent(name, params) {
  (0, _analytics.logEvent)(analytics, name, params);
};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/lottieAnimation/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/tabmenu/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/menu/index.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/firebase/index.js");

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/lottieAnimation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.applyToElements = applyToElements;
exports.applyToElement = applyToElement;

var _lottieAnimation = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/lottieAnimation/lottieAnimation.js");

var _lottieAnimation2 = _interopRequireDefault(_lottieAnimation);

var _extractOptions = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/utility/extractOptions.js");

var _extractOptions2 = _interopRequireDefault(_extractOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function applyToElements() {

    var lottieElements = document.querySelectorAll("[data-lottie]");
    console.log("Finding Lottie Animations ", lottieElements);
    var lottieElementsArray = Array.prototype.slice.call(lottieElements);

    lottieElementsArray.forEach(applyToElement);
}

function applyToElement(element) {

    var options = Object.assign({}, _lottieAnimation2.default.DEFAULTS, (0, _extractOptions2.default)("lottie", element));
    var instance = new _lottieAnimation2.default(element, options);
    element.instance = instance;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/lottieAnimation/lottieAnimation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lottie = __webpack_require__("external \"lottie\"");

var _lottie2 = _interopRequireDefault(_lottie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LottieAnimation = function () {
    function LottieAnimation(element, options) {
        _classCallCheck(this, LottieAnimation);

        this.element = element;

        if (options.path) {
            this.path = options.path;
        } else {
            this.path = "animations/" + options.name + ".json";
        }

        this.renderer = options.renderer;
        this.autoplay = options.autoplay;
        this.name = options.name;
        this.loop = options.loop;
        this.delay = options.delay;

        this.init();
    }

    _createClass(LottieAnimation, [{
        key: "init",
        value: function init() {

            var self = this;

            _lottie2.default.loadAnimation({
                container: self.element,
                renderer: self.renderer,
                loop: self.loop,
                autoplay: false, //always false, use delay logic
                name: self.name,
                path: self.path
            });

            if (this.autoplay) {
                setTimeout(this.play, this.delay);
            }
        }
    }, {
        key: "play",
        value: function play() {
            _lottie2.default.play(this.name);
        }
    }]);

    return LottieAnimation;
}();

LottieAnimation.DEFAULTS = {
    loop: false,
    autoplay: true,
    renderer: "svg"
};

exports.default = LottieAnimation;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/menu/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.applyToElement = applyToElement;

var _menu = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/menu/menu.js");

var _menu2 = _interopRequireDefault(_menu);

var _extractOptions = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/utility/extractOptions.js");

var _extractOptions2 = _interopRequireDefault(_extractOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function applyToElement(element) {

    if (!window.document.menu) {

        var options = Object.assign({}, _menu2.default.DEFAULTS, (0, _extractOptions2.default)("menu", element));
        var instance = new _menu2.default(element, options);

        window.document.menu = instance;
    }
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/menu/menu.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ally = __webpack_require__("external \"ally\"");

var _ally2 = _interopRequireDefault(_ally);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Menu = function () {
    function Menu(element, options) {
        _classCallCheck(this, Menu);

        this.openSelector = options.openSelector;
        this.enableButtons = this.enableButtons;

        //nav element may be dynamically removed and added again, 
        //observer will reinitiate with new nav element by passing 
        //it to this.init(element)
        this.init(element);

        //start observers
        this.watch();
    }

    _createClass(Menu, [{
        key: "init",
        value: function init(element) {
            this.element = element;
            this.document = this.element.ownerDocument;
            this.bodyWidth = this.document.body.getBoundingClientRect().width;
            this.app = this.document.getElementById("app");
            this.openMenuElements = this.getOpenMenuElements();
        }
    }, {
        key: "watch",
        value: function watch() {

            var self = this;

            //----- create observers

            //observes change in nav class attribute as nav open/close
            this.classObserver = new MutationObserver(this.classMutationCallback.bind(self));
            //observes resizing of page
            this.resizeObserver = new window.ResizeObserver(this.resizeMutationCallback.bind(self));
            //observes nav being added/removed from page, enabling/disabling classObserver and resizeObserver
            this.navObserver = new MutationObserver(this.navAddRemoveCallback.bind(self));

            //------ start watching

            //begin observing add/remove of nav to page
            this.navObserver.observe(this.app, { subtree: false, childList: true });

            //nav will have already been rendered before observer started, so check if nav exists, and if so 
            //start observing class change on nav and resize on page events
            if (this.document.querySelector("#main-nav")) {
                this.observeNavToggleState(true);
            }
        }

        /**
         * Check if buttons should be disabled
         * If the page is less than 1200px in width, page is in mobile mode, 
         * and if the menu is not collapsed, buttons in main content areas 
         * should be disabled
         * @returns boolean
         */

    }, {
        key: "calcButtonsDisabled",
        value: function calcButtonsDisabled() {
            var isDisabled = this.bodyWidth < 1200 && !this.isMenuCollapsed();
            return isDisabled;
        }

        /**
         * Test if nav contains class 'menu-collapsed
         * @returns boolean
         */

    }, {
        key: "isMenuCollapsed",
        value: function isMenuCollapsed() {
            return this.element.classList.contains("menu-collapsed");
        }

        /**
         * Toggle observation on nav class attribute and page resize events
         * @param {boolean} enabled 
         */

    }, {
        key: "observeNavToggleState",
        value: function observeNavToggleState(enabled) {

            if (enabled) {
                this.classObserver.observe(this.element, { attributes: true });
                this.resizeObserver.observe(this.app);
            } else {
                this.classObserver.disconnect();
                this.resizeObserver.disconnect();
            }
        }

        /**
         * Callback on class attribute change on Nav. Will toggle button state depending on 
         * if the nav is determined to be opened or close.
         * @param {*} mutationsList 
         */

    }, {
        key: "classMutationCallback",
        value: function classMutationCallback(mutationsList) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = mutationsList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var mutation = _step.value;

                    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        var collapsed = this.isMenuCollapsed();
                        this.toggleButtons(collapsed);
                        this.toggleAriaHideMainContent(!collapsed);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        /**
         * Callback on document body resize event, will update the determined bodyWidth, and 
         * execute a refresh on Button state.
         * @param {*} entries 
         */

    }, {
        key: "resizeMutationCallback",
        value: function resizeMutationCallback(entries) {
            this.bodyWidth = entries[0].contentRect.width;
            this.refreshButtonState();
        }

        /**
         * Callback on add/remove node as direct child to app div. For each node 
         * added or removed, will execute the appropriate callback
         * @param {*} mutationsList 
         */

    }, {
        key: "navAddRemoveCallback",
        value: function navAddRemoveCallback(mutationsList) {
            var self = this;
            mutationsList.forEach(function (mutation) {
                mutation.removedNodes.forEach(self.onRemoveNav.bind(self));
                mutation.addedNodes.forEach(self.onAddNav.bind(self));
            });
        }

        /**
         * On remove child node of app, determine if nav and stop observing 
         * class and resize mutations
         * @param {*} node 
         */

    }, {
        key: "onRemoveNav",
        value: function onRemoveNav(node) {
            if (node.id == 'main-nav') {
                this.observeNavToggleState(false);
            }
        }

        /**
         * On add child node of app, determine if nav, and reinitatilise 
         * variables with new element and begin observing class and 
         * resize mutations
         * @param {*} node 
         */

    }, {
        key: "onAddNav",
        value: function onAddNav(node) {
            if (node.id == 'main-nav') {
                this.init(node);
                this.observeNavToggleState(true);
            }
        }

        /**
         * Toggle buttons enabled/disabled depending on 
         * determined nav state.
         */

    }, {
        key: "refreshButtonState",
        value: function refreshButtonState() {

            var collapsed = !this.calcButtonsDisabled();
            this.toggleButtons(collapsed);
            this.toggleAriaHideMainContent(!collapsed);
        }

        /**
         * Enable/Disable buttons depending on provided boolean value
         * @param {boolean} enabled 
         */

    }, {
        key: "toggleButtons",
        value: function toggleButtons(enabled) {
            if (enabled) {
                this.enableButtons();
            } else {
                this.disableButtons();
            }
        }
    }, {
        key: "enableButtons",
        value: function enableButtons() {
            if (this.handle) {
                this.handle.disengage();
                this.handle = null;
            }
        }
    }, {
        key: "toggleAriaHideMainContent",
        value: function toggleAriaHideMainContent(hide) {
            this.document.querySelector("main").setAttribute("aria-hidden", hide);
        }
    }, {
        key: "disableButtons",
        value: function disableButtons() {
            if (!this.handle) {
                this.handle = _ally2.default.maintain.disabled({
                    context: this.document.body,
                    filter: [this.element, this.document.querySelector("header")].concat(this.openMenuElements)
                });
            }
        }
    }, {
        key: "getOpenMenuElements",
        value: function getOpenMenuElements() {
            return this.findAsArray(this.document, this.openSelector);
        }
    }, {
        key: "findAsArray",
        value: function findAsArray(ele, selector) {
            var col = ele.querySelectorAll(selector);
            return Array.prototype.slice.call(col);
        }
    }]);

    return Menu;
}();

Menu.DEFAULTS = {
    openSelector: ".menu-open"
};

exports.default = Menu;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/tabmenu/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.applyToElements = applyToElements;
exports.applyToElement = applyToElement;
exports.focusOnTab = focusOnTab;

var _tabmenu = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/tabmenu/tabmenu.js");

var _tabmenu2 = _interopRequireDefault(_tabmenu);

var _extractOptions = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/utility/extractOptions.js");

var _extractOptions2 = _interopRequireDefault(_extractOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function applyToElements() {

    var tabmenuElements = document.querySelectorAll("[data-tabmenu]");
    console.log(tabmenuElements);
    var tabmenuElementsArray = Array.prototype.slice.call(tabmenuElements);

    tabmenuElementsArray.forEach(applyToElement);
}

function applyToElement(element) {

    var options = Object.assign({}, _tabmenu2.default.DEFAULTS, (0, _extractOptions2.default)("tabmenu", element));
    var instance = new _tabmenu2.default(element, options);

    element.instance = instance;
}

function focusOnTab(element) {

    element.instance.focusOnTab();
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/tabmenu/tabmenu.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TabMenu = function () {
    function TabMenu(element, options) {
        _classCallCheck(this, TabMenu);

        this.options = options;

        this.init(element);
        this.watch();
    }

    _createClass(TabMenu, [{
        key: 'init',
        value: function init(element) {
            console.log("initiating");
            this.element = element;
            this.elementId = element.id;
            this.tabs = this.findAsArray(this.element, 'label[role="tab"]');
            this.selectedTab = this.element.querySelector('label[role="tab"].selected');
            if (this.selectedTab) {
                this.selectedTab.focus();
            }
            this.panels = this.findAsArray(this.element, '[role="tabpanel"]');
        }
    }, {
        key: 'refresh',
        value: function refresh() {
            this.init();
        }
    }, {
        key: 'watch',
        value: function watch() {
            var self = this;

            this.tabs.forEach(function (el) {
                return el.addEventListener("keydown", self.onTabKeydown.bind(self));
            });
        }
    }, {
        key: 'focusOnTab',
        value: function focusOnTab() {
            var self = this;
            this.selectedTab = this.element.querySelector('label[role="tab"].selected');

            if (this.selectedTab && window.document.activeElement == window.document.body) {
                this.selectedTab.focus();

                this.init(this.element);
                this.tabs.forEach(function (el) {
                    return el.addEventListener("keydown", self.onTabKeydown.bind(self));
                });
            }
        }
    }, {
        key: 'onAddTabMenu',
        value: function onAddTabMenu(node) {
            //console.log("add: ", {"node.id": node.id, "this.elementId": this.elementId});
            if (node.id == this.elementId || node == this.element) {
                console.log("added");
                this.init(node);
            }
        }
    }, {
        key: 'onRemoveTabMenu',
        value: function onRemoveTabMenu(node) {
            if (node.id == this.elementId || node == this.element) {
                console.log("removed");
            }
        }
    }, {
        key: 'findAsArray',
        value: function findAsArray(ele, selector) {
            var col = ele.querySelectorAll(selector);
            return Array.prototype.slice.call(col);
        }
    }, {
        key: 'onTabKeydown',
        value: function onTabKeydown(e) {
            console.log("test");
            var index = Array.prototype.indexOf.call(this.tabs, e.currentTarget);
            var dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : e.which === 40 ? 'down' : null;
            if (dir !== null) {
                e.preventDefault();
                console.log(this.panels, index);
                dir === 'down' ? this.panels[index].focus() : this.tabs[dir] ? this.switchTab(e.currentTarget, this.tabs[dir]) : void 0;
            }
        }
    }, {
        key: 'switchTab',
        value: function switchTab(oldTab, newTab) {
            newTab.click();
            newTab.focus();
        }
    }]);

    return TabMenu;
}();

exports.default = TabMenu;


TabMenu.DEFAULTS = {};

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/regenerator-runtime/runtime.js");

var _debug = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _ally = __webpack_require__("external \"ally\"");

var _ally2 = _interopRequireDefault(_ally);

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/index.js");

__webpack_require__("/tool/project/client/src/core/vendor/index.js");

var _tabmenu = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/tabmenu/index.js");

var tabmenu = _interopRequireWildcard(_tabmenu);

var _menu = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/menu/index.js");

var menu = _interopRequireWildcard(_menu);

var _lottieAnimation = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/lottieAnimation/index.js");

var lottieAnimation = _interopRequireWildcard(_lottieAnimation);

var _firebase = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/firebase/index.js");

var firebase = _interopRequireWildcard(_firebase);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var log = (0, _debug2.default)('fusion-core');

var focusSource = _ally2.default.style.focusSource();

globalThis.resetFocus = function () {
    console.log("resetting focus to document");
    document.activeElement.blur();
};

globalThis.SetFocusToElement = function (elementId) {
    var element = document.getElementById(elementId);
    if (element != null) {
        element.focus();
    }
};

globalThis.SetLoadingAnimation = function (elementId) {
    var loadingAnimationContainer = document.getElementById('loadingAnimationContainer');
    if (loadingAnimationContainer) {
        var loadingAnimation = loadingAnimationContainer.children[0];
        if (loadingAnimation) {
            lottie.applyToElement(loadingAnimation);
        }
    }
};

globalThis.ScrollToId = function (id) {
    var element = document.getElementById(id);
    if (element instanceof HTMLElement) {
        element.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
        });
        element.focus();
    }
};

globalThis.ScrollToIdIfNeeded = function (id) {
    var element = document.getElementById(id);
    if (element instanceof HTMLElement) {
        if (element.scrollIntoViewIfNeeded) {
            element.scrollIntoViewIfNeeded(false);
            element.focus();
        }
    }
};

globalThis.ScrollToTop = function (id) {
    globalThis.scrollTo({ top: 0, behavior: 'smooth' });
};

globalThis.getAddClaimImageHeight = function () {

    // access DOM here
    var div = document.getElementById("add-claim-img-c");
    return div.offsetWidth / 2 + "px";
};

globalThis.moveCursorToEnd = function (id) {
    var input = document.getElementById(id);
    input.focus();
    var s = input.value;
    if (s.length) {
        globalThis.setTimeout(function () {
            input.setSelectionRange(s.length, s.length);
        }, 0);
    }
};

globalThis.openDatePicker = function (datePickerId) {
    var dateInput = document.getElementById(datePickerId);
    dateInput.show();
};

globalThis.goBack = function () {
    globalThis.history.back();
};

globalThis.goBackMany = function (delta) {
    globalThis.history.go(delta);
};

globalThis.loadIframe = function (bytesBase64) {
    var iframe = document.createElement('iframe');
    iframe.style.width = "100%";
    iframe.style.height = "780px";
    iframe.src = "data:application/pdf;base64," + bytesBase64;
    document.getElementById("content").appendChild(iframe);
    document.getElementById("display-pdf").remove();
};

globalThis.saveAsFile = function (filename, bytesBase64) {
    var link = document.createElement('a');
    link.download = filename;
    link.href = "data:application/octet-stream;base64," + bytesBase64;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

globalThis.saveBinaryAsFile = function (filename, byteArray) {
    var blob = new Blob([byteArray], { type: 'application/octet-stream' });
    var url = URL.createObjectURL(blob);
    var link = document.createElement('a');
    link.download = filename;
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

globalThis.initialiseDatePicker = function (dotNetHelper, datePickerId) {
    console.log(dotNetHelper, datePickerId);
    globalThis.customElements.whenDefined("duet-date-picker").then(function () {
        var datePicker = document.getElementById(datePickerId);
        if (datePicker) {
            datePicker.addEventListener("duetChange", function (event) {
                console.log(event.detail);
                dotNetHelper.invokeMethodAsync('UpdateDateValue', datePicker.value);
            });
        }
    });
};

globalThis.getRadioValue = function (radioName) {
    var selectedRadio = document.querySelector('input[name="' + radioName + '"]:checked');
    if (selectedRadio != null) {
        return selectedRadio.value;
    } else {
        return null;
    }
};

globalThis.setRadioChecked = function (id) {
    var selectedRadio = document.querySelector('input[id="' + id + '"]');
    if (selectedRadio != null) {
        selectedRadio.checked = true;
    }
};

globalThis.setRadioButtonItemWidths = function () {
    var maxWidth = 110;
    var radioItems = document.querySelectorAll('.radio-field-label');
    var radioContainer = document.querySelector('.radio-question__answers');
    // find max width based on content
    radioItems.forEach(function (item) {
        var width = item.offsetWidth;
        if (width > maxWidth) {
            maxWidth = width;
        }
    });

    // apply max width to all items
    radioItems.forEach(function (item) {
        item.style.width = maxWidth + "px";
    });

    radioContainer.style.gridTemplateColumns = "repeat(auto-fill, " + maxWidth + "px)";
};

globalThis.logEvent = function (name, params) {
    firebase.doLogEvent(name, params);
};

globalThis.CustomClickListener = {};
globalThis.addClickListener = function (dotNetHelper, scopeSelector, elementsSelector, methodIdentifier) {
    var scopeEl = document.querySelector(scopeSelector);
    if (!scopeEl) {
        return;
    }

    var listenerKey = scopeSelector + "_" + methodIdentifier;
    var elements = scopeEl.querySelectorAll(elementsSelector);

    // we don't want to double up on event handling, so remove any existing custom click handler
    if (typeof globalThis.CustomClickListener[listenerKey] === 'function') {
        elements.forEach(function (el) {
            el.removeEventListener('click', globalThis.CustomClickListener[listenerKey]);
            globalThis.CustomClickListener[listenerKey] = undefined;
        });
    }

    globalThis.CustomClickListener[listenerKey] = function (e) {
        e.preventDefault();
        e.stopPropagation();
        dotNetHelper.invokeMethodAsync(methodIdentifier);
    };

    elements.forEach(function (el) {
        el.addEventListener('click', globalThis.CustomClickListener[listenerKey]);
    });
};

globalThis.ScrollRight = function (Element, dotNetHelper) {
    if (document.getElementById(Element)) {
        var scrollView = document.getElementById(Element);

        if (document.getElementById('cover-card-id')) {

            var screenWidth = scrollView.offsetWidth;

            var scrollViewWidth = scrollView.scrollWidth;
            var scrollLeftWidth = scrollView.scrollLeft;
            var remainingWidth = scrollViewWidth - screenWidth - scrollLeftWidth;
            var contentWidth = document.getElementById('cover-card-id').scrollWidth;

            if (remainingWidth > contentWidth) {
                scrollView.scrollBy({
                    top: 0, left: contentWidth + 10, behavior: "smooth"
                });
            } else {
                var widthToScroll = contentWidth - remainingWidth;
                scrollView.scrollBy({
                    top: 0, left: remainingWidth, behavior: "smooth"
                });
                dotNetHelper.invokeMethodAsync('IsScrollViewReachRightEnd', true);
            }
        }
    }
};

globalThis.ScrollLeft = function (Element, dotNetHelper) {
    if (document.getElementById(Element)) {
        if (document.getElementById('cover-card-id')) {
            var scrollView = document.getElementById(Element);
            var contentWidth = document.getElementById('cover-card-id').offsetWidth;
            var scrollLeftWidth = scrollView.scrollLeft;
            if (scrollLeftWidth > contentWidth) {
                document.getElementById(Element).scrollBy({
                    top: 0, left: -document.getElementById('cover-card-id').offsetWidth - 10, behavior: "smooth"
                });
            } else {
                document.getElementById(Element).scrollBy({
                    top: 0, left: -scrollLeftWidth, behavior: "smooth"
                });
                dotNetHelper.invokeMethodAsync('IsScrollViewReachLeftEnd', true);
            }
        }
    }
};

globalThis.HorizontalScrollJSHelper = function (dotNetHelper) {

    if (document.getElementById("horizontal_container_scroll")) {
        var el = document.getElementById("horizontal_container_scroll");
        if (Math.abs(el.scrollLeft) === el.scrollWidth - el.clientWidth) {
            dotNetHelper.invokeMethodAsync('IsScrollViewReachRightEnd', true);
        } else {
            dotNetHelper.invokeMethodAsync('IsScrollViewReachRightEnd', false);
        }

        if (el.scrollLeft <= 0) {
            dotNetHelper.invokeMethodAsync('IsScrollViewReachLeftEnd', true);
        } else {
            dotNetHelper.invokeMethodAsync('IsScrollViewReachLeftEnd', false);
        }
    }
};

globalThis.GetHeightByElementId = function (Element, Width) {
    if (document.getElementById(Element)) {
        return document.getElementById(Element).offsetHeight;
    }
};

globalThis.setModalPopUpPageAndIntercept = function (containerId, html) {
    var container = document.getElementById(containerId);
    container.innerHTML = html;

    container.querySelectorAll("a[href]").forEach(function (a) {
        a.addEventListener("click", function (e) {
            e.preventDefault(); // stop default navigation
            var href = a.getAttribute("href");

            DotNet.invokeMethodAsync("MobileHealthFund.Web", "ModalPopUpPageAndInterceptHandleLinkClickById", href);
        });
    });
};

globalThis.tabmenu = tabmenu;
globalThis.lottie = lottieAnimation;
globalThis.menu = menu;

function base64UrlEncode(uint8array) {
    var str = "";
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = uint8array[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var byte = _step.value;

            str += String.fromCodePoint(byte);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var b64 = globalThis.btoa(str).replaceAll("+", "-").replaceAll("/", "_");

    var paddingIndex = b64.indexOf("=");
    return paddingIndex === -1 ? b64 : b64.substring(0, paddingIndex);
}

globalThis.encryptData = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload, jwk) {
        var importJwk, importedKey, cek, rawCek, encryptedKey, iv, header, headerJson, headerB64, additionalData, payloadBytes, encryptedContent, encryptedContentBytes, tagLength, ciphertext, tag, encryptedKeyB64, ivB64, ciphertextB64, tagB64;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;

                        // 1. Prepare Key Import
                        // Ensure JWK properties are set correctly for Web Crypto
                        importJwk = {
                            kty: jwk.kty,
                            e: jwk.e,
                            n: jwk.n,
                            alg: "RSA-OAEP-256",
                            ext: true,
                            key_ops: ["encrypt"]
                        };
                        _context.next = 4;
                        return globalThis.crypto.subtle.importKey("jwk", importJwk, {
                            name: "RSA-OAEP",
                            hash: "SHA-256"
                        }, false, ["encrypt"]);

                    case 4:
                        importedKey = _context.sent;
                        _context.next = 7;
                        return globalThis.crypto.subtle.generateKey({
                            name: "AES-GCM",
                            length: 256
                        }, true, // extractable
                        ["encrypt"]);

                    case 7:
                        cek = _context.sent;
                        _context.next = 10;
                        return globalThis.crypto.subtle.exportKey("raw", cek);

                    case 10:
                        rawCek = _context.sent;
                        _context.next = 13;
                        return globalThis.crypto.subtle.encrypt({
                            name: "RSA-OAEP"
                        }, importedKey, rawCek);

                    case 13:
                        encryptedKey = _context.sent;


                        // 4. Encrypt Payload with CEK (AES-GCM)
                        iv = globalThis.crypto.getRandomValues(new Uint8Array(12));

                        // Prepare Header

                        header = {
                            alg: "RSA-OAEP-256",
                            enc: "A256GCM",
                            kid: jwk.kid
                        };
                        headerJson = JSON.stringify(header);
                        headerB64 = base64UrlEncode(new TextEncoder().encode(headerJson));

                        // AAD is the ASCII(BASE64URL(UTF8(JWE Header)))

                        additionalData = new TextEncoder().encode(headerB64);
                        payloadBytes = new TextEncoder().encode(payload);
                        _context.next = 22;
                        return globalThis.crypto.subtle.encrypt({
                            name: "AES-GCM",
                            iv: iv,
                            additionalData: additionalData,
                            tagLength: 128
                        }, cek, payloadBytes);

                    case 22:
                        encryptedContent = _context.sent;
                        encryptedContentBytes = new Uint8Array(encryptedContent);
                        tagLength = 16;
                        ciphertext = encryptedContentBytes.slice(0, encryptedContentBytes.length - tagLength);
                        tag = encryptedContentBytes.slice(encryptedContentBytes.length - tagLength);

                        // 5. Construct JWE

                        encryptedKeyB64 = base64UrlEncode(new Uint8Array(encryptedKey));
                        ivB64 = base64UrlEncode(iv);
                        ciphertextB64 = base64UrlEncode(ciphertext);
                        tagB64 = base64UrlEncode(tag);
                        return _context.abrupt("return", headerB64 + "." + encryptedKeyB64 + "." + ivB64 + "." + ciphertextB64 + "." + tagB64);

                    case 34:
                        _context.prev = 34;
                        _context.t0 = _context["catch"](0);

                        console.error("Encryption failed", _context.t0);
                        throw _context.t0;

                    case 38:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee, undefined, [[0, 34]]);
    }));

    return function (_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

globalThis.validateToken = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(jwk, token) {
        var importJwk, importedKey, parts, header, payload, signature, signatureStr, signatureBytes, i, dataBytes, isValid, payloadStr, decodedPayload, payloadJson, now;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.prev = 0;
                        importJwk = {
                            kty: jwk.kty,
                            e: jwk.e,
                            n: jwk.n,
                            alg: "RS256",
                            ext: true,
                            key_ops: ["verify"]
                        };
                        _context2.next = 4;
                        return globalThis.crypto.subtle.importKey("jwk", importJwk, {
                            name: "RSASSA-PKCS1-v1_5",
                            hash: "SHA-256"
                        }, false, ["verify"]);

                    case 4:
                        importedKey = _context2.sent;
                        parts = token.split(".");

                        if (!(parts.length !== 3)) {
                            _context2.next = 8;
                            break;
                        }

                        return _context2.abrupt("return", false);

                    case 8:
                        header = parts[0];
                        payload = parts[1];
                        signature = parts[2];

                        // Base64URL to Uint8Array

                        signatureStr = window.atob(signature.replaceAll("-", "+").replaceAll("_", "/"));
                        signatureBytes = new Uint8Array(signatureStr.length);

                        for (i = 0; i < signatureStr.length; i++) {
                            signatureBytes[i] = signatureStr.codePointAt(i);
                        }

                        dataBytes = new TextEncoder().encode(header + "." + payload);
                        _context2.next = 17;
                        return globalThis.crypto.subtle.verify("RSASSA-PKCS1-v1_5", importedKey, signatureBytes, dataBytes);

                    case 17:
                        isValid = _context2.sent;

                        if (isValid) {
                            _context2.next = 20;
                            break;
                        }

                        return _context2.abrupt("return", false);

                    case 20:
                        _context2.prev = 20;
                        payloadStr = payload.replaceAll("-", "+").replaceAll("_", "/");
                        // Add padding if missing

                        while (payloadStr.length % 4 !== 0) {
                            payloadStr += "=";
                        }

                        decodedPayload = globalThis.atob(payloadStr);
                        payloadJson = JSON.parse(decodedPayload);
                        now = Math.floor(Date.now() / 1000);

                        if (!(payloadJson.exp && now >= payloadJson.exp)) {
                            _context2.next = 29;
                            break;
                        }

                        console.error("Token expired");
                        return _context2.abrupt("return", false);

                    case 29:
                        if (!(payloadJson.nbf && now < payloadJson.nbf)) {
                            _context2.next = 32;
                            break;
                        }

                        console.error("Token not yet valid (nbf)");
                        return _context2.abrupt("return", false);

                    case 32:
                        _context2.next = 38;
                        break;

                    case 34:
                        _context2.prev = 34;
                        _context2.t0 = _context2["catch"](20);

                        console.error("Token payload validation failed", _context2.t0);
                        return _context2.abrupt("return", false);

                    case 38:
                        return _context2.abrupt("return", true);

                    case 41:
                        _context2.prev = 41;
                        _context2.t1 = _context2["catch"](0);

                        console.error("Token validation failed", _context2.t1);
                        return _context2.abrupt("return", false);

                    case 45:
                    case "end":
                        return _context2.stop();
                }
            }
        }, _callee2, undefined, [[0, 41], [20, 34]]);
    }));

    return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/utility/extractOptions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (name, element) {
	return extractComponentOptions(name, getOptionData(element));
};

/*
 * Unlike other utility files, this is not adding functions to the utility scope
 * This is instead included by some components
 */

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

function camelCase(string) {
	return string.replace(/^([A-Z])|[\s-_](\w)/g, function (match, p1, p2) {
		if (p2) {
			return p2.toUpperCase();
		}

		return p1.toLowerCase();
	});
}

function getOptionData(element) {
	var dataset = element.dataset;
	var data = {};

	for (var prop in dataset) {
		if (dataset.hasOwnProperty(prop)) {
			data[prop] = dataset[prop];
		}
	}
	return data || {};
}

function extractComponentOptions(name, data) {
	var options = {};
	var cameledName = camelCase(name);
	for (var prop in data) {
		if (prop.startsWith(cameledName) && prop !== cameledName) {
			options[camelCase(prop.slice(cameledName.length))] = getJSONValue(data[prop]);
		}
	}
	return options;
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/analytics/dist/esm/index.esm2017.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.settings = exports.setUserProperties = exports.setUserId = exports.setCurrentScreen = exports.setAnalyticsCollectionEnabled = exports.logEvent = exports.isSupported = exports.initializeAnalytics = exports.getAnalytics = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ERRORS;

/**
 * Wrapped gtag logic when gtag is called with 'config' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param measurementId GA Measurement ID to set config for.
 * @param gtagParams Gtag config params to set.
 */
var gtagOnConfig = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, measurementId, gtagParams) {
        var correspondingAppId, dynamicConfigResults, foundConfig;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        // If config is already fetched, we know the appId and can use it to look up what FID promise we
                        /// are waiting for, and wait only on that one.
                        correspondingAppId = measurementIdToAppId[measurementId];
                        _context.prev = 1;

                        if (!correspondingAppId) {
                            _context.next = 7;
                            break;
                        }

                        _context.next = 5;
                        return initializationPromisesMap[correspondingAppId];

                    case 5:
                        _context.next = 14;
                        break;

                    case 7:
                        _context.next = 9;
                        return promiseAllSettled(dynamicConfigPromisesList);

                    case 9:
                        dynamicConfigResults = _context.sent;
                        foundConfig = dynamicConfigResults.find(function (config) {
                            return config.measurementId === measurementId;
                        });

                        if (!foundConfig) {
                            _context.next = 14;
                            break;
                        }

                        _context.next = 14;
                        return initializationPromisesMap[foundConfig.appId];

                    case 14:
                        _context.next = 19;
                        break;

                    case 16:
                        _context.prev = 16;
                        _context.t0 = _context['catch'](1);

                        logger.error(_context.t0);

                    case 19:
                        gtagCore("config" /* CONFIG */, measurementId, gtagParams);

                    case 20:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this, [[1, 16]]);
    }));

    return function gtagOnConfig(_x, _x2, _x3, _x4, _x5, _x6) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Wrapped gtag logic when gtag is called with 'event' command.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementId GA Measurement ID to log event to.
 * @param gtagParams Params to log with this event.
 */


var gtagOnEvent = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementId, gtagParams) {
        var initializationPromisesToWaitFor, gaSendToList, dynamicConfigResults, _loop, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, sendToId, _ret;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.prev = 0;
                        initializationPromisesToWaitFor = [];
                        // If there's a 'send_to' param, check if any ID specified matches
                        // an initializeIds() promise we are waiting for.

                        if (!(gtagParams && gtagParams['send_to'])) {
                            _context2.next = 36;
                            break;
                        }

                        gaSendToList = gtagParams['send_to'];
                        // Make it an array if is isn't, so it can be dealt with the same way.

                        if (!Array.isArray(gaSendToList)) {
                            gaSendToList = [gaSendToList];
                        }
                        // Checking 'send_to' fields requires having all measurement ID results back from
                        // the dynamic config fetch.
                        _context2.next = 7;
                        return promiseAllSettled(dynamicConfigPromisesList);

                    case 7:
                        dynamicConfigResults = _context2.sent;

                        _loop = function _loop(sendToId) {
                            // Any fetched dynamic measurement ID that matches this 'send_to' ID
                            var foundConfig = dynamicConfigResults.find(function (config) {
                                return config.measurementId === sendToId;
                            });
                            var initializationPromise = foundConfig && initializationPromisesMap[foundConfig.appId];
                            if (initializationPromise) {
                                initializationPromisesToWaitFor.push(initializationPromise);
                            } else {
                                // Found an item in 'send_to' that is not associated
                                // directly with an FID, possibly a group.  Empty this array,
                                // exit the loop early, and let it get populated below.
                                initializationPromisesToWaitFor = [];
                                return 'break';
                            }
                        };

                        _iteratorNormalCompletion = true;
                        _didIteratorError = false;
                        _iteratorError = undefined;
                        _context2.prev = 12;
                        _iterator = gaSendToList[Symbol.iterator]();

                    case 14:
                        if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                            _context2.next = 22;
                            break;
                        }

                        sendToId = _step.value;
                        _ret = _loop(sendToId);

                        if (!(_ret === 'break')) {
                            _context2.next = 19;
                            break;
                        }

                        return _context2.abrupt('break', 22);

                    case 19:
                        _iteratorNormalCompletion = true;
                        _context2.next = 14;
                        break;

                    case 22:
                        _context2.next = 28;
                        break;

                    case 24:
                        _context2.prev = 24;
                        _context2.t0 = _context2['catch'](12);
                        _didIteratorError = true;
                        _iteratorError = _context2.t0;

                    case 28:
                        _context2.prev = 28;
                        _context2.prev = 29;

                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }

                    case 31:
                        _context2.prev = 31;

                        if (!_didIteratorError) {
                            _context2.next = 34;
                            break;
                        }

                        throw _iteratorError;

                    case 34:
                        return _context2.finish(31);

                    case 35:
                        return _context2.finish(28);

                    case 36:
                        // This will be unpopulated if there was no 'send_to' field , or
                        // if not all entries in the 'send_to' field could be mapped to
                        // a FID. In these cases, wait on all pending initialization promises.
                        if (initializationPromisesToWaitFor.length === 0) {
                            initializationPromisesToWaitFor = Object.values(initializationPromisesMap);
                        }
                        // Run core gtag function with args after all relevant initialization
                        // promises have been resolved.
                        _context2.next = 39;
                        return Promise.all(initializationPromisesToWaitFor);

                    case 39:
                        // Workaround for http://b/141370449 - third argument cannot be undefined.
                        gtagCore("event" /* EVENT */, measurementId, gtagParams || {});
                        _context2.next = 45;
                        break;

                    case 42:
                        _context2.prev = 42;
                        _context2.t1 = _context2['catch'](0);

                        logger.error(_context2.t1);

                    case 45:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this, [[0, 42], [12, 24, 28, 36], [29,, 31, 35]]);
    }));

    return function gtagOnEvent(_x7, _x8, _x9, _x10, _x11) {
        return _ref2.apply(this, arguments);
    };
}();
/**
 * Wraps a standard gtag function with extra code to wait for completion of
 * relevant initialization promises before sending requests.
 *
 * @param gtagCore Basic gtag function that just appends to dataLayer.
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 */


/**
 * Fetches dynamic config from backend.
 * @param app Firebase app to fetch config for.
 */
var fetchDynamicConfig = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(appFields) {
        var _a, appId, apiKey, request, appUrl, response, errorMessage, jsonResponse;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        appId = appFields.appId, apiKey = appFields.apiKey;
                        request = {
                            method: 'GET',
                            headers: getHeaders(apiKey)
                        };
                        appUrl = DYNAMIC_CONFIG_URL.replace('{app-id}', appId);
                        _context4.next = 5;
                        return fetch(appUrl, request);

                    case 5:
                        response = _context4.sent;

                        if (!(response.status !== 200 && response.status !== 304)) {
                            _context4.next = 18;
                            break;
                        }

                        errorMessage = '';
                        _context4.prev = 8;
                        _context4.next = 11;
                        return response.json();

                    case 11:
                        jsonResponse = _context4.sent;

                        if ((_a = jsonResponse.error) === null || _a === void 0 ? void 0 : _a.message) {
                            errorMessage = jsonResponse.error.message;
                        }
                        _context4.next = 17;
                        break;

                    case 15:
                        _context4.prev = 15;
                        _context4.t0 = _context4['catch'](8);

                    case 17:
                        throw ERROR_FACTORY.create("config-fetch-failed" /* CONFIG_FETCH_FAILED */, {
                            httpStatus: response.status,
                            responseMessage: errorMessage
                        });

                    case 18:
                        return _context4.abrupt('return', response.json());

                    case 19:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this, [[8, 15]]);
    }));

    return function fetchDynamicConfig(_x17) {
        return _ref4.apply(this, arguments);
    };
}();
/**
 * Fetches dynamic config from backend, retrying if failed.
 * @param app Firebase app to fetch config for.
 */


var fetchDynamicConfigWithRetry = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(app) {
        var _this = this;

        var retryData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultRetryData;
        var timeoutMillis = arguments[2];

        var _app$options, appId, apiKey, measurementId, throttleMetadata, signal;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        _app$options = app.options, appId = _app$options.appId, apiKey = _app$options.apiKey, measurementId = _app$options.measurementId;

                        if (appId) {
                            _context6.next = 3;
                            break;
                        }

                        throw ERROR_FACTORY.create("no-app-id" /* NO_APP_ID */);

                    case 3:
                        if (apiKey) {
                            _context6.next = 7;
                            break;
                        }

                        if (!measurementId) {
                            _context6.next = 6;
                            break;
                        }

                        return _context6.abrupt('return', {
                            measurementId: measurementId,
                            appId: appId
                        });

                    case 6:
                        throw ERROR_FACTORY.create("no-api-key" /* NO_API_KEY */);

                    case 7:
                        throttleMetadata = retryData.getThrottleMetadata(appId) || {
                            backoffCount: 0,
                            throttleEndTimeMillis: Date.now()
                        };
                        signal = new AnalyticsAbortSignal();

                        setTimeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                                while (1) {
                                    switch (_context5.prev = _context5.next) {
                                        case 0:
                                            // Note a very low delay, eg < 10ms, can elapse before listeners are initialized.
                                            signal.abort();

                                        case 1:
                                        case 'end':
                                            return _context5.stop();
                                    }
                                }
                            }, _callee5, _this);
                        })), timeoutMillis !== undefined ? timeoutMillis : FETCH_TIMEOUT_MILLIS);
                        return _context6.abrupt('return', attemptFetchDynamicConfigWithRetry({ appId: appId, apiKey: apiKey, measurementId: measurementId }, throttleMetadata, signal, retryData));

                    case 11:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function fetchDynamicConfigWithRetry(_x19) {
        return _ref5.apply(this, arguments);
    };
}();
/**
 * Runs one retry attempt.
 * @param appFields Necessary app config fields.
 * @param throttleMetadata Ongoing metadata to determine throttling times.
 * @param signal Abort signal.
 */


var attemptFetchDynamicConfigWithRetry = function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(appFields, _ref7, signal) {
        var throttleEndTimeMillis = _ref7.throttleEndTimeMillis,
            backoffCount = _ref7.backoffCount;
        var retryData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultRetryData;
        var appId, measurementId, response, backoffMillis, throttleMetadata;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        appId = appFields.appId, measurementId = appFields.measurementId;
                        // Starts with a (potentially zero) timeout to support resumption from stored state.
                        // Ensures the throttle end time is honored if the last attempt timed out.
                        // Note the SDK will never make a request if the fetch timeout expires at this point.

                        _context7.prev = 1;
                        _context7.next = 4;
                        return setAbortableTimeout(signal, throttleEndTimeMillis);

                    case 4:
                        _context7.next = 12;
                        break;

                    case 6:
                        _context7.prev = 6;
                        _context7.t0 = _context7['catch'](1);

                        if (!measurementId) {
                            _context7.next = 11;
                            break;
                        }

                        logger.warn('Timed out fetching this Firebase app\'s measurement ID from the server.' + (' Falling back to the measurement ID ' + measurementId) + (' provided in the "measurementId" field in the local Firebase config. [' + _context7.t0.message + ']'));
                        return _context7.abrupt('return', { appId: appId, measurementId: measurementId });

                    case 11:
                        throw _context7.t0;

                    case 12:
                        _context7.prev = 12;
                        _context7.next = 15;
                        return fetchDynamicConfig(appFields);

                    case 15:
                        response = _context7.sent;

                        // Note the SDK only clears throttle state if response is success or non-retriable.
                        retryData.deleteThrottleMetadata(appId);
                        return _context7.abrupt('return', response);

                    case 20:
                        _context7.prev = 20;
                        _context7.t1 = _context7['catch'](12);

                        if (isRetriableError(_context7.t1)) {
                            _context7.next = 30;
                            break;
                        }

                        retryData.deleteThrottleMetadata(appId);

                        if (!measurementId) {
                            _context7.next = 29;
                            break;
                        }

                        logger.warn('Failed to fetch this Firebase app\'s measurement ID from the server.' + (' Falling back to the measurement ID ' + measurementId) + (' provided in the "measurementId" field in the local Firebase config. [' + _context7.t1.message + ']'));
                        return _context7.abrupt('return', { appId: appId, measurementId: measurementId });

                    case 29:
                        throw _context7.t1;

                    case 30:
                        backoffMillis = Number(_context7.t1.customData.httpStatus) === 503 ? (0, _util.calculateBackoffMillis)(backoffCount, retryData.intervalMillis, LONG_RETRY_FACTOR) : (0, _util.calculateBackoffMillis)(backoffCount, retryData.intervalMillis);
                        // Increments backoff state.

                        throttleMetadata = {
                            throttleEndTimeMillis: Date.now() + backoffMillis,
                            backoffCount: backoffCount + 1
                        };
                        // Persists state.

                        retryData.setThrottleMetadata(appId, throttleMetadata);
                        logger.debug('Calling attemptFetch again in ' + backoffMillis + ' millis');
                        return _context7.abrupt('return', attemptFetchDynamicConfigWithRetry(appFields, throttleMetadata, signal, retryData));

                    case 35:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, this, [[1, 6], [12, 20]]);
    }));

    return function attemptFetchDynamicConfigWithRetry(_x21, _x22, _x23) {
        return _ref8.apply(this, arguments);
    };
}();
/**
 * Supports waiting on a backoff by:
 *
 * <ul>
 *   <li>Promisifying setTimeout, so we can set a timeout in our Promise chain</li>
 *   <li>Listening on a signal bus for abort events, just like the Fetch API</li>
 *   <li>Failing in the same way the Fetch API fails, so timing out a live request and a throttled
 *       request appear the same.</li>
 * </ul>
 *
 * <p>Visible for testing.
 */


/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var validateIndexedDB = function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        if ((0, _util.isIndexedDBAvailable)()) {
                            _context8.next = 5;
                            break;
                        }

                        logger.warn(ERROR_FACTORY.create("indexeddb-unavailable" /* INDEXEDDB_UNAVAILABLE */, {
                            errorInfo: 'IndexedDB is not available in this environment.'
                        }).message);
                        return _context8.abrupt('return', false);

                    case 5:
                        _context8.prev = 5;
                        _context8.next = 8;
                        return (0, _util.validateIndexedDBOpenable)();

                    case 8:
                        _context8.next = 14;
                        break;

                    case 10:
                        _context8.prev = 10;
                        _context8.t0 = _context8['catch'](5);

                        logger.warn(ERROR_FACTORY.create("indexeddb-unavailable" /* INDEXEDDB_UNAVAILABLE */, {
                            errorInfo: _context8.t0
                        }).message);
                        return _context8.abrupt('return', false);

                    case 14:
                        return _context8.abrupt('return', true);

                    case 15:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, this, [[5, 10]]);
    }));

    return function validateIndexedDB() {
        return _ref9.apply(this, arguments);
    };
}();
/**
 * Initialize the analytics instance in gtag.js by calling config command with fid.
 *
 * NOTE: We combine analytics initialization and setting fid together because we want fid to be
 * part of the `page_view` event that's sent during the initialization
 * @param app Firebase app
 * @param gtagCore The gtag function that's not wrapped.
 * @param dynamicConfigPromisesList Array of all dynamic config promises.
 * @param measurementIdToAppId Maps measurementID to appID.
 * @param installations _FirebaseInstallationsInternal instance.
 *
 * @returns Measurement ID.
 */


var _initializeAnalytics = function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCore, dataLayerName, options) {
        var _a, dynamicConfigPromise, fidPromise, _ref11, _ref12, dynamicConfig, fid, configProperties;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        dynamicConfigPromise = fetchDynamicConfigWithRetry(app);
                        // Once fetched, map measurementIds to appId, for ease of lookup in wrapped gtag function.

                        dynamicConfigPromise.then(function (config) {
                            measurementIdToAppId[config.measurementId] = config.appId;
                            if (app.options.measurementId && config.measurementId !== app.options.measurementId) {
                                logger.warn('The measurement ID in the local Firebase config (' + app.options.measurementId + ')' + (' does not match the measurement ID fetched from the server (' + config.measurementId + ').') + ' To ensure analytics events are always sent to the correct Analytics property,' + ' update the' + ' measurement ID field in the local config or remove it from the local config.');
                            }
                        }).catch(function (e) {
                            return logger.error(e);
                        });
                        // Add to list to track state of all dynamic config promises.
                        dynamicConfigPromisesList.push(dynamicConfigPromise);
                        fidPromise = validateIndexedDB().then(function (envIsValid) {
                            if (envIsValid) {
                                return installations.getId();
                            } else {
                                return undefined;
                            }
                        });
                        _context9.next = 6;
                        return Promise.all([dynamicConfigPromise, fidPromise]);

                    case 6:
                        _ref11 = _context9.sent;
                        _ref12 = _slicedToArray(_ref11, 2);
                        dynamicConfig = _ref12[0];
                        fid = _ref12[1];

                        // Detect if user has already put the gtag <script> tag on this page.
                        if (!findGtagScriptOnPage()) {
                            insertScriptTag(dataLayerName, dynamicConfig.measurementId);
                        }
                        // This command initializes gtag.js and only needs to be called once for the entire web app,
                        // but since it is idempotent, we can call it multiple times.
                        // We keep it together with other initialization logic for better code structure.
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        gtagCore('js', new Date());
                        // User config added first. We don't want users to accidentally overwrite
                        // base Firebase config properties.
                        configProperties = (_a = options === null || options === void 0 ? void 0 : options.config) !== null && _a !== void 0 ? _a : {};
                        // guard against developers accidentally setting properties with prefix `firebase_`

                        configProperties[ORIGIN_KEY] = 'firebase';
                        configProperties.update = true;
                        if (fid != null) {
                            configProperties[GA_FID_KEY] = fid;
                        }
                        // It should be the first config command called on this GA-ID
                        // Initialize this GA-ID and set FID on it using the gtag config API.
                        // Note: This will trigger a page_view event unless 'send_page_view' is set to false in
                        // `configProperties`.
                        gtagCore("config" /* CONFIG */, dynamicConfig.measurementId, configProperties);
                        return _context9.abrupt('return', dynamicConfig.measurementId);

                    case 18:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee9, this);
    }));

    return function _initializeAnalytics(_x24, _x25, _x26, _x27, _x28, _x29, _x30) {
        return _ref10.apply(this, arguments);
    };
}();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Analytics Service class.
 */


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Logs an analytics event through the Firebase SDK.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param eventName Google Analytics event name, choose from standard list or use a custom string.
 * @param eventParams Analytics event parameters.
 */
var logEvent$1 = function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(gtagFunction, initializationPromise, eventName, eventParams, options) {
        var measurementId, params;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
                switch (_context10.prev = _context10.next) {
                    case 0:
                        if (!(options && options.global)) {
                            _context10.next = 5;
                            break;
                        }

                        gtagFunction("event" /* EVENT */, eventName, eventParams);
                        return _context10.abrupt('return');

                    case 5:
                        _context10.next = 7;
                        return initializationPromise;

                    case 7:
                        measurementId = _context10.sent;
                        params = Object.assign(Object.assign({}, eventParams), { 'send_to': measurementId });

                        gtagFunction("event" /* EVENT */, eventName, params);

                    case 10:
                    case 'end':
                        return _context10.stop();
                }
            }
        }, _callee10, this);
    }));

    return function logEvent$1(_x31, _x32, _x33, _x34, _x35) {
        return _ref13.apply(this, arguments);
    };
}();
/**
 * Set screen_name parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param screenName Screen name string to set.
 */


var setCurrentScreen$1 = function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(gtagFunction, initializationPromise, screenName, options) {
        var measurementId;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
                switch (_context11.prev = _context11.next) {
                    case 0:
                        if (!(options && options.global)) {
                            _context11.next = 5;
                            break;
                        }

                        gtagFunction("set" /* SET */, { 'screen_name': screenName });
                        return _context11.abrupt('return', Promise.resolve());

                    case 5:
                        _context11.next = 7;
                        return initializationPromise;

                    case 7:
                        measurementId = _context11.sent;

                        gtagFunction("config" /* CONFIG */, measurementId, {
                            update: true,
                            'screen_name': screenName
                        });

                    case 9:
                    case 'end':
                        return _context11.stop();
                }
            }
        }, _callee11, this);
    }));

    return function setCurrentScreen$1(_x36, _x37, _x38, _x39) {
        return _ref14.apply(this, arguments);
    };
}();
/**
 * Set user_id parameter for this Google Analytics ID.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param id User ID string to set
 */


var setUserId$1 = function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(gtagFunction, initializationPromise, id, options) {
        var measurementId;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
                switch (_context12.prev = _context12.next) {
                    case 0:
                        if (!(options && options.global)) {
                            _context12.next = 5;
                            break;
                        }

                        gtagFunction("set" /* SET */, { 'user_id': id });
                        return _context12.abrupt('return', Promise.resolve());

                    case 5:
                        _context12.next = 7;
                        return initializationPromise;

                    case 7:
                        measurementId = _context12.sent;

                        gtagFunction("config" /* CONFIG */, measurementId, {
                            update: true,
                            'user_id': id
                        });

                    case 9:
                    case 'end':
                        return _context12.stop();
                }
            }
        }, _callee12, this);
    }));

    return function setUserId$1(_x40, _x41, _x42, _x43) {
        return _ref15.apply(this, arguments);
    };
}();
/**
 * Set all other user properties other than user_id and screen_name.
 *
 * @param gtagFunction Wrapped gtag function that waits for fid to be set before sending an event
 * @param properties Map of user properties to set
 */


var setUserProperties$1 = function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(gtagFunction, initializationPromise, properties, options) {
        var flatProperties, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, key, measurementId;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
                switch (_context13.prev = _context13.next) {
                    case 0:
                        if (!(options && options.global)) {
                            _context13.next = 25;
                            break;
                        }

                        flatProperties = {};
                        _iteratorNormalCompletion3 = true;
                        _didIteratorError3 = false;
                        _iteratorError3 = undefined;
                        _context13.prev = 5;

                        for (_iterator3 = Object.keys(properties)[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            key = _step3.value;

                            // use dot notation for merge behavior in gtag.js
                            flatProperties['user_properties.' + key] = properties[key];
                        }
                        _context13.next = 13;
                        break;

                    case 9:
                        _context13.prev = 9;
                        _context13.t0 = _context13['catch'](5);
                        _didIteratorError3 = true;
                        _iteratorError3 = _context13.t0;

                    case 13:
                        _context13.prev = 13;
                        _context13.prev = 14;

                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }

                    case 16:
                        _context13.prev = 16;

                        if (!_didIteratorError3) {
                            _context13.next = 19;
                            break;
                        }

                        throw _iteratorError3;

                    case 19:
                        return _context13.finish(16);

                    case 20:
                        return _context13.finish(13);

                    case 21:
                        gtagFunction("set" /* SET */, flatProperties);
                        return _context13.abrupt('return', Promise.resolve());

                    case 25:
                        _context13.next = 27;
                        return initializationPromise;

                    case 27:
                        measurementId = _context13.sent;

                        gtagFunction("config" /* CONFIG */, measurementId, {
                            update: true,
                            'user_properties': properties
                        });

                    case 29:
                    case 'end':
                        return _context13.stop();
                }
            }
        }, _callee13, this, [[5, 9, 13, 21], [14,, 16, 20]]);
    }));

    return function setUserProperties$1(_x44, _x45, _x46, _x47) {
        return _ref16.apply(this, arguments);
    };
}();
/**
 * Set whether collection is enabled for this ID.
 *
 * @param enabled If true, collection is enabled for this ID.
 */


var setAnalyticsCollectionEnabled$1 = function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(initializationPromise, enabled) {
        var measurementId;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) {
                switch (_context14.prev = _context14.next) {
                    case 0:
                        _context14.next = 2;
                        return initializationPromise;

                    case 2:
                        measurementId = _context14.sent;

                        window['ga-disable-' + measurementId] = !enabled;

                    case 4:
                    case 'end':
                        return _context14.stop();
                }
            }
        }, _callee14, this);
    }));

    return function setAnalyticsCollectionEnabled$1(_x48, _x49) {
        return _ref17.apply(this, arguments);
    };
}();

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */


/**
 * This is a public static method provided to users that wraps four different checks:
 *
 * 1. Check if it's not a browser extension environment.
 * 2. Check if cookies are enabled in current browser.
 * 3. Check if IndexedDB is supported by the browser environment.
 * 4. Check if the current browser context is valid for using `IndexedDB.open()`.
 *
 * @public
 *
 */
var isSupported = function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var isDBOpenable;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
                switch (_context15.prev = _context15.next) {
                    case 0:
                        if (!(0, _util.isBrowserExtension)()) {
                            _context15.next = 2;
                            break;
                        }

                        return _context15.abrupt('return', false);

                    case 2:
                        if ((0, _util.areCookiesEnabled)()) {
                            _context15.next = 4;
                            break;
                        }

                        return _context15.abrupt('return', false);

                    case 4:
                        if ((0, _util.isIndexedDBAvailable)()) {
                            _context15.next = 6;
                            break;
                        }

                        return _context15.abrupt('return', false);

                    case 6:
                        _context15.prev = 6;
                        _context15.next = 9;
                        return (0, _util.validateIndexedDBOpenable)();

                    case 9:
                        isDBOpenable = _context15.sent;
                        return _context15.abrupt('return', isDBOpenable);

                    case 13:
                        _context15.prev = 13;
                        _context15.t0 = _context15['catch'](6);
                        return _context15.abrupt('return', false);

                    case 16:
                    case 'end':
                        return _context15.stop();
                }
            }
        }, _callee15, this, [[6, 13]]);
    }));

    return function isSupported() {
        return _ref18.apply(this, arguments);
    };
}();
/**
 * Use gtag `config` command to set `screen_name`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param screenName - Screen name to set.
 */


var _app = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/app/dist/esm/index.esm2017.js");

var _logger = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/logger/dist/esm/index.esm2017.js");

var _util = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/util/dist/index.esm2017.js");

var _component = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/component/dist/esm/index.esm2017.js");

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/installations/dist/esm/index.esm2017.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Type constant for Firebase Analytics.
 */
var ANALYTICS_TYPE = 'analytics';
// Key to attach FID to in gtag params.
var GA_FID_KEY = 'firebase_id';
var ORIGIN_KEY = 'origin';
var FETCH_TIMEOUT_MILLIS = 60 * 1000;
var DYNAMIC_CONFIG_URL = 'https://firebase.googleapis.com/v1alpha/projects/-/apps/{app-id}/webConfig';
var GTAG_URL = 'https://www.googletagmanager.com/gtag/js';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logger = new _logger.Logger('@firebase/analytics');

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Makeshift polyfill for Promise.allSettled(). Resolves when all promises
 * have either resolved or rejected.
 *
 * @param promises Array of promises to wait for.
 */
function promiseAllSettled(promises) {
    return Promise.all(promises.map(function (promise) {
        return promise.catch(function (e) {
            return e;
        });
    }));
}
/**
 * Inserts gtag script tag into the page to asynchronously download gtag.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */
function insertScriptTag(dataLayerName, measurementId) {
    var script = document.createElement('script');
    // We are not providing an analyticsId in the URL because it would trigger a `page_view`
    // without fid. We will initialize ga-id using gtag (config) command together with fid.
    script.src = GTAG_URL + '?l=' + dataLayerName + '&id=' + measurementId;
    script.async = true;
    document.head.appendChild(script);
}
/**
 * Get reference to, or create, global datalayer.
 * @param dataLayerName Name of datalayer (most often the default, "_dataLayer").
 */
function getOrCreateDataLayer(dataLayerName) {
    // Check for existing dataLayer and create if needed.
    var dataLayer = [];
    if (Array.isArray(window[dataLayerName])) {
        dataLayer = window[dataLayerName];
    } else {
        window[dataLayerName] = dataLayer;
    }
    return dataLayer;
}function wrapGtag(gtagCore,
/**
 * Allows wrapped gtag calls to wait on whichever intialization promises are required,
 * depending on the contents of the gtag params' `send_to` field, if any.
 */
initializationPromisesMap,
/**
 * Wrapped gtag calls sometimes require all dynamic config fetches to have returned
 * before determining what initialization promises (which include FIDs) to wait for.
 */
dynamicConfigPromisesList,
/**
 * Wrapped gtag config calls can narrow down which initialization promise (with FID)
 * to wait for if the measurementId is already fetched, by getting the corresponding appId,
 * which is the key for the initialization promises map.
 */
measurementIdToAppId) {
    /**
     * Wrapper around gtag that ensures FID is sent with gtag calls.
     * @param command Gtag command type.
     * @param idOrNameOrParams Measurement ID if command is EVENT/CONFIG, params if command is SET.
     * @param gtagParams Params if event is EVENT/CONFIG.
     */
    var gtagWrapper = function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(command, idOrNameOrParams, gtagParams) {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.prev = 0;

                            if (!(command === "event" /* EVENT */)) {
                                _context3.next = 6;
                                break;
                            }

                            _context3.next = 4;
                            return gtagOnEvent(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, idOrNameOrParams, gtagParams);

                        case 4:
                            _context3.next = 12;
                            break;

                        case 6:
                            if (!(command === "config" /* CONFIG */)) {
                                _context3.next = 11;
                                break;
                            }

                            _context3.next = 9;
                            return gtagOnConfig(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, idOrNameOrParams, gtagParams);

                        case 9:
                            _context3.next = 12;
                            break;

                        case 11:
                            // If SET, second arg must be params.
                            gtagCore("set" /* SET */, idOrNameOrParams);

                        case 12:
                            _context3.next = 17;
                            break;

                        case 14:
                            _context3.prev = 14;
                            _context3.t0 = _context3['catch'](0);

                            logger.error(_context3.t0);

                        case 17:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, this, [[0, 14]]);
        }));

        return function gtagWrapper(_x12, _x13, _x14) {
            return _ref3.apply(this, arguments);
        };
    }();

    return gtagWrapper;
}
/**
 * Creates global gtag function or wraps existing one if found.
 * This wrapped function attaches Firebase instance ID (FID) to gtag 'config' and
 * 'event' calls that belong to the GAID associated with this Firebase instance.
 *
 * @param initializationPromisesMap Map of appIds to their initialization promises.
 * @param dynamicConfigPromisesList Array of dynamic config fetch promises.
 * @param measurementIdToAppId Map of GA measurementIDs to corresponding Firebase appId.
 * @param dataLayerName Name of global GA datalayer array.
 * @param gtagFunctionName Name of global gtag function ("gtag" if not user-specified).
 */
function wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagFunctionName) {
    // Create a basic core gtag function
    var gtagCore = function gtagCore() {
        for (var _len = arguments.length, _args = Array(_len), _key = 0; _key < _len; _key++) {
            _args[_key] = arguments[_key];
        }

        // Must push IArguments object, not an array.
        window[dataLayerName].push(arguments);
    };
    // Replace it with existing one if found
    if (window[gtagFunctionName] && typeof window[gtagFunctionName] === 'function') {
        // @ts-ignore
        gtagCore = window[gtagFunctionName];
    }
    window[gtagFunctionName] = wrapGtag(gtagCore, initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId);
    return {
        gtagCore: gtagCore,
        wrappedGtag: window[gtagFunctionName]
    };
}
/**
 * Returns first script tag in DOM matching our gtag url pattern.
 */
function findGtagScriptOnPage() {
    var scriptTags = window.document.getElementsByTagName('script');
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = Object.values(scriptTags)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var tag = _step2.value;

            if (tag.src && tag.src.includes(GTAG_URL)) {
                return tag;
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return null;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ERRORS = (_ERRORS = {}, _defineProperty(_ERRORS, "already-exists" /* ALREADY_EXISTS */, 'A Firebase Analytics instance with the appId {$id} ' + ' already exists. ' + 'Only one Firebase Analytics instance can be created for each appId.'), _defineProperty(_ERRORS, "already-initialized" /* ALREADY_INITIALIZED */, 'initializeAnalytics() cannot be called again with different options than those ' + 'it was initially called with. It can be called again with the same options to ' + 'return the existing instance, or getAnalytics() can be used ' + 'to get a reference to the already-intialized instance.'), _defineProperty(_ERRORS, "already-initialized-settings" /* ALREADY_INITIALIZED_SETTINGS */, 'Firebase Analytics has already been initialized.' + 'settings() must be called before initializing any Analytics instance' + 'or it will have no effect.'), _defineProperty(_ERRORS, "interop-component-reg-failed" /* INTEROP_COMPONENT_REG_FAILED */, 'Firebase Analytics Interop Component failed to instantiate: {$reason}'), _defineProperty(_ERRORS, "invalid-analytics-context" /* INVALID_ANALYTICS_CONTEXT */, 'Firebase Analytics is not supported in this environment. ' + 'Wrap initialization of analytics in analytics.isSupported() ' + 'to prevent initialization in unsupported environments. Details: {$errorInfo}'), _defineProperty(_ERRORS, "indexeddb-unavailable" /* INDEXEDDB_UNAVAILABLE */, 'IndexedDB unavailable or restricted in this environment. ' + 'Wrap initialization of analytics in analytics.isSupported() ' + 'to prevent initialization in unsupported environments. Details: {$errorInfo}'), _defineProperty(_ERRORS, "fetch-throttle" /* FETCH_THROTTLE */, 'The config fetch request timed out while in an exponential backoff state.' + ' Unix timestamp in milliseconds when fetch request throttling ends: {$throttleEndTimeMillis}.'), _defineProperty(_ERRORS, "config-fetch-failed" /* CONFIG_FETCH_FAILED */, 'Dynamic config fetch failed: [{$httpStatus}] {$responseMessage}'), _defineProperty(_ERRORS, "no-api-key" /* NO_API_KEY */, 'The "apiKey" field is empty in the local Firebase config. Firebase Analytics requires this field to' + 'contain a valid API key.'), _defineProperty(_ERRORS, "no-app-id" /* NO_APP_ID */, 'The "appId" field is empty in the local Firebase config. Firebase Analytics requires this field to' + 'contain a valid app ID.'), _ERRORS);
var ERROR_FACTORY = new _util.ErrorFactory('analytics', 'Analytics', ERRORS);

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Backoff factor for 503 errors, which we want to be conservative about
 * to avoid overloading servers. Each retry interval will be
 * BASE_INTERVAL_MILLIS * LONG_RETRY_FACTOR ^ retryCount, so the second one
 * will be ~30 seconds (with fuzzing).
 */
var LONG_RETRY_FACTOR = 30;
/**
 * Base wait interval to multiplied by backoffFactor^backoffCount.
 */
var BASE_INTERVAL_MILLIS = 1000;
/**
 * Stubbable retry data storage class.
 */

var RetryData = function () {
    function RetryData() {
        var throttleMetadata = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var intervalMillis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : BASE_INTERVAL_MILLIS;

        _classCallCheck(this, RetryData);

        this.throttleMetadata = throttleMetadata;
        this.intervalMillis = intervalMillis;
    }

    _createClass(RetryData, [{
        key: 'getThrottleMetadata',
        value: function getThrottleMetadata(appId) {
            return this.throttleMetadata[appId];
        }
    }, {
        key: 'setThrottleMetadata',
        value: function setThrottleMetadata(appId, metadata) {
            this.throttleMetadata[appId] = metadata;
        }
    }, {
        key: 'deleteThrottleMetadata',
        value: function deleteThrottleMetadata(appId) {
            delete this.throttleMetadata[appId];
        }
    }]);

    return RetryData;
}();

var defaultRetryData = new RetryData();
/**
 * Set GET request headers.
 * @param apiKey App API key.
 */
function getHeaders(apiKey) {
    return new Headers({
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}function setAbortableTimeout(signal, throttleEndTimeMillis) {
    return new Promise(function (resolve, reject) {
        // Derives backoff from given end time, normalizing negative numbers to zero.
        var backoffMillis = Math.max(throttleEndTimeMillis - Date.now(), 0);
        var timeout = setTimeout(resolve, backoffMillis);
        // Adds listener, rather than sets onabort, because signal is a shared object.
        signal.addEventListener(function () {
            clearTimeout(timeout);
            // If the request completes before this timeout, the rejection has no effect.
            reject(ERROR_FACTORY.create("fetch-throttle" /* FETCH_THROTTLE */, {
                throttleEndTimeMillis: throttleEndTimeMillis
            }));
        });
    });
}
/**
 * Returns true if the {@link Error} indicates a fetch request may succeed later.
 */
function isRetriableError(e) {
    if (!(e instanceof _util.FirebaseError) || !e.customData) {
        return false;
    }
    // Uses string index defined by ErrorData, which FirebaseError implements.
    var httpStatus = Number(e.customData['httpStatus']);
    return httpStatus === 429 || httpStatus === 500 || httpStatus === 503 || httpStatus === 504;
}
/**
 * Shims a minimal AbortSignal (copied from Remote Config).
 *
 * <p>AbortController's AbortSignal conveniently decouples fetch timeout logic from other aspects
 * of networking, such as retries. Firebase doesn't use AbortController enough to justify a
 * polyfill recommendation, like we do with the Fetch API, but this minimal shim can easily be
 * swapped out if/when we do.
 */

var AnalyticsAbortSignal = function () {
    function AnalyticsAbortSignal() {
        _classCallCheck(this, AnalyticsAbortSignal);

        this.listeners = [];
    }

    _createClass(AnalyticsAbortSignal, [{
        key: 'addEventListener',
        value: function addEventListener(listener) {
            this.listeners.push(listener);
        }
    }, {
        key: 'abort',
        value: function abort() {
            this.listeners.forEach(function (listener) {
                return listener();
            });
        }
    }]);

    return AnalyticsAbortSignal;
}();

var AnalyticsService = function () {
    function AnalyticsService(app) {
        _classCallCheck(this, AnalyticsService);

        this.app = app;
    }

    _createClass(AnalyticsService, [{
        key: '_delete',
        value: function _delete() {
            delete initializationPromisesMap[this.app.options.appId];
            return Promise.resolve();
        }
    }]);

    return AnalyticsService;
}();
/**
 * Maps appId to full initialization promise. Wrapped gtag calls must wait on
 * all or some of these, depending on the call's `send_to` param and the status
 * of the dynamic config fetches (see below).
 */


var initializationPromisesMap = {};
/**
 * List of dynamic config fetch promises. In certain cases, wrapped gtag calls
 * wait on all these to be complete in order to determine if it can selectively
 * wait for only certain initialization (FID) promises or if it must wait for all.
 */
var dynamicConfigPromisesList = [];
/**
 * Maps fetched measurementIds to appId. Populated when the app's dynamic config
 * fetch completes. If already populated, gtag config calls can use this to
 * selectively wait for only this app's initialization promise (FID) instead of all
 * initialization promises.
 */
var measurementIdToAppId = {};
/**
 * Name for window global data layer array used by GA: defaults to 'dataLayer'.
 */
var dataLayerName = 'dataLayer';
/**
 * Name for window global gtag function used by GA: defaults to 'gtag'.
 */
var gtagName = 'gtag';
/**
 * Reproduction of standard gtag function or reference to existing
 * gtag function on window object.
 */
var gtagCoreFunction = void 0;
/**
 * Wrapper around gtag function that ensures FID is sent with all
 * relevant event and config calls.
 */
var wrappedGtagFunction = void 0;
/**
 * Flag to ensure page initialization steps (creation or wrapping of
 * dataLayer and gtag script) are only run once per page load.
 */
var globalInitDone = false;
/**
 * Configures Firebase Analytics to use custom `gtag` or `dataLayer` names.
 * Intended to be used if `gtag.js` script has been installed on
 * this page independently of Firebase Analytics, and is using non-default
 * names for either the `gtag` function or for `dataLayer`.
 * Must be called before calling `getAnalytics()` or it won't
 * have any effect.
 *
 * @public
 *
 * @param options - Custom gtag and dataLayer names.
 */
function settings(options) {
    if (globalInitDone) {
        throw ERROR_FACTORY.create("already-initialized" /* ALREADY_INITIALIZED */);
    }
    if (options.dataLayerName) {
        dataLayerName = options.dataLayerName;
    }
    if (options.gtagName) {
        gtagName = options.gtagName;
    }
}
/**
 * Returns true if no environment mismatch is found.
 * If environment mismatches are found, throws an INVALID_ANALYTICS_CONTEXT
 * error that also lists details for each mismatch found.
 */
function warnOnBrowserContextMismatch() {
    var mismatchedEnvMessages = [];
    if ((0, _util.isBrowserExtension)()) {
        mismatchedEnvMessages.push('This is a browser extension environment.');
    }
    if (!(0, _util.areCookiesEnabled)()) {
        mismatchedEnvMessages.push('Cookies are not available.');
    }
    if (mismatchedEnvMessages.length > 0) {
        var details = mismatchedEnvMessages.map(function (message, index) {
            return '(' + (index + 1) + ') ' + message;
        }).join(' ');
        var err = ERROR_FACTORY.create("invalid-analytics-context" /* INVALID_ANALYTICS_CONTEXT */, {
            errorInfo: details
        });
        logger.warn(err.message);
    }
}
/**
 * Analytics instance factory.
 * @internal
 */
function factory(app, installations, options) {
    warnOnBrowserContextMismatch();
    var appId = app.options.appId;
    if (!appId) {
        throw ERROR_FACTORY.create("no-app-id" /* NO_APP_ID */);
    }
    if (!app.options.apiKey) {
        if (app.options.measurementId) {
            logger.warn('The "apiKey" field is empty in the local Firebase config. This is needed to fetch the latest' + (' measurement ID for this Firebase app. Falling back to the measurement ID ' + app.options.measurementId) + ' provided in the "measurementId" field in the local Firebase config.');
        } else {
            throw ERROR_FACTORY.create("no-api-key" /* NO_API_KEY */);
        }
    }
    if (initializationPromisesMap[appId] != null) {
        throw ERROR_FACTORY.create("already-exists" /* ALREADY_EXISTS */, {
            id: appId
        });
    }
    if (!globalInitDone) {
        // Steps here should only be done once per page: creation or wrapping
        // of dataLayer and global gtag function.
        getOrCreateDataLayer(dataLayerName);

        var _wrapOrCreateGtag = wrapOrCreateGtag(initializationPromisesMap, dynamicConfigPromisesList, measurementIdToAppId, dataLayerName, gtagName),
            wrappedGtag = _wrapOrCreateGtag.wrappedGtag,
            gtagCore = _wrapOrCreateGtag.gtagCore;

        wrappedGtagFunction = wrappedGtag;
        gtagCoreFunction = gtagCore;
        globalInitDone = true;
    }
    // Async but non-blocking.
    // This map reflects the completion state of all promises for each appId.
    initializationPromisesMap[appId] = _initializeAnalytics(app, dynamicConfigPromisesList, measurementIdToAppId, installations, gtagCoreFunction, dataLayerName, options);
    var analyticsInstance = new AnalyticsService(app);
    return analyticsInstance;
}function getAnalytics() {
    var app = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _app.getApp)();

    app = (0, _util.getModularInstance)(app);
    // Dependencies
    var analyticsProvider = (0, _app._getProvider)(app, ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        return analyticsProvider.getImmediate();
    }
    return initializeAnalytics(app);
}
/**
 * Returns an {@link Analytics} instance for the given app.
 *
 * @public
 *
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 */
function initializeAnalytics(app) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // Dependencies
    var analyticsProvider = (0, _app._getProvider)(app, ANALYTICS_TYPE);
    if (analyticsProvider.isInitialized()) {
        var existingInstance = analyticsProvider.getImmediate();
        if ((0, _util.deepEqual)(options, analyticsProvider.getOptions())) {
            return existingInstance;
        } else {
            throw ERROR_FACTORY.create("already-initialized" /* ALREADY_INITIALIZED */);
        }
    }
    var analyticsInstance = analyticsProvider.initialize({ options: options });
    return analyticsInstance;
}function setCurrentScreen(analyticsInstance, screenName, options) {
    analyticsInstance = (0, _util.getModularInstance)(analyticsInstance);
    setCurrentScreen$1(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId], screenName, options).catch(function (e) {
        return logger.error(e);
    });
}
/**
 * Use gtag `config` command to set `user_id`.
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param id - User ID to set.
 */
function setUserId(analyticsInstance, id, options) {
    analyticsInstance = (0, _util.getModularInstance)(analyticsInstance);
    setUserId$1(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId], id, options).catch(function (e) {
        return logger.error(e);
    });
}
/**
 * Use gtag `config` command to set all params specified.
 *
 * @public
 */
function setUserProperties(analyticsInstance, properties, options) {
    analyticsInstance = (0, _util.getModularInstance)(analyticsInstance);
    setUserProperties$1(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId], properties, options).catch(function (e) {
        return logger.error(e);
    });
}
/**
 * Sets whether Google Analytics collection is enabled for this app on this device.
 * Sets global `window['ga-disable-analyticsId'] = true;`
 *
 * @public
 *
 * @param analyticsInstance - The {@link Analytics} instance.
 * @param enabled - If true, enables collection, if false, disables it.
 */
function setAnalyticsCollectionEnabled(analyticsInstance, enabled) {
    analyticsInstance = (0, _util.getModularInstance)(analyticsInstance);
    setAnalyticsCollectionEnabled$1(initializationPromisesMap[analyticsInstance.app.options.appId], enabled).catch(function (e) {
        return logger.error(e);
    });
}
/**
 * Sends a Google Analytics event with given `eventParams`. This method
 * automatically associates this logged event with this Firebase web
 * app instance on this device.
 * List of official event parameters can be found in the gtag.js
 * reference documentation:
 * {@link https://developers.google.com/gtagjs/reference/ga4-events
 * | the GA4 reference documentation}.
 *
 * @public
 */
function _logEvent(analyticsInstance, eventName, eventParams, options) {
    analyticsInstance = (0, _util.getModularInstance)(analyticsInstance);
    logEvent$1(wrappedGtagFunction, initializationPromisesMap[analyticsInstance.app.options.appId], eventName, eventParams, options).catch(function (e) {
        return logger.error(e);
    });
}

var name = "@firebase/analytics";
var version = "0.7.8";

/**
 * Firebase Analytics
 *
 * @packageDocumentation
 */
function registerAnalytics() {
    (0, _app._registerComponent)(new _component.Component(ANALYTICS_TYPE, function (container, _ref19) {
        var analyticsOptions = _ref19.options;

        // getImmediate for FirebaseApp will always succeed
        var app = container.getProvider('app').getImmediate();
        var installations = container.getProvider('installations-internal').getImmediate();
        return factory(app, installations, analyticsOptions);
    }, "PUBLIC" /* PUBLIC */));
    (0, _app._registerComponent)(new _component.Component('analytics-internal', internalFactory, "PRIVATE" /* PRIVATE */));
    (0, _app.registerVersion)(name, version);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, _app.registerVersion)(name, version, 'esm2017');
    function internalFactory(container) {
        try {
            var analytics = container.getProvider(ANALYTICS_TYPE).getImmediate();
            return {
                logEvent: function logEvent(eventName, eventParams, options) {
                    return _logEvent(analytics, eventName, eventParams, options);
                }
            };
        } catch (e) {
            throw ERROR_FACTORY.create("interop-component-reg-failed" /* INTEROP_COMPONENT_REG_FAILED */, {
                reason: e
            });
        }
    }
}
registerAnalytics();

exports.getAnalytics = getAnalytics;
exports.initializeAnalytics = initializeAnalytics;
exports.isSupported = isSupported;
exports.logEvent = _logEvent;
exports.setAnalyticsCollectionEnabled = setAnalyticsCollectionEnabled;
exports.setCurrentScreen = setCurrentScreen;
exports.setUserId = setUserId;
exports.setUserProperties = setUserProperties;
exports.settings = settings;
//# sourceMappingURL=index.esm2017.js.map

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/app/dist/esm/index.esm2017.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setLogLevel = exports.registerVersion = exports.onLog = exports.initializeApp = exports.getApps = exports.getApp = exports.deleteApp = exports._removeServiceInstance = exports._registerComponent = exports._getProvider = exports._components = exports._clearComponents = exports._apps = exports._addOrOverwriteComponent = exports._addComponent = exports._DEFAULT_ENTRY_NAME = exports.SDK_VERSION = exports.FirebaseError = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _PLATFORM_LOG_STRING, _ERRORS;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */
var deleteApp = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(app) {
        var name;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        name = app.name;

                        if (!_apps.has(name)) {
                            _context.next = 6;
                            break;
                        }

                        _apps.delete(name);
                        _context.next = 5;
                        return Promise.all(app.container.getProviders().map(function (provider) {
                            return provider.delete();
                        }));

                    case 5:
                        app.isDeleted = true;

                    case 6:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function deleteApp(_x4) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */


var readHeartbeatsFromIndexedDB = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(app) {
        var db;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.prev = 0;
                        _context2.next = 3;
                        return getDbPromise();

                    case 3:
                        db = _context2.sent;
                        return _context2.abrupt('return', db.transaction(STORE_NAME).objectStore(STORE_NAME).get(computeKey(app)));

                    case 7:
                        _context2.prev = 7;
                        _context2.t0 = _context2['catch'](0);
                        throw ERROR_FACTORY.create("storage-get" /* STORAGE_GET */, {
                            originalErrorMessage: _context2.t0.message
                        });

                    case 10:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this, [[0, 7]]);
    }));

    return function readHeartbeatsFromIndexedDB(_x5) {
        return _ref2.apply(this, arguments);
    };
}();

var writeHeartbeatsToIndexedDB = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(app, heartbeatObject) {
        var db, tx, objectStore;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.prev = 0;
                        _context3.next = 3;
                        return getDbPromise();

                    case 3:
                        db = _context3.sent;
                        tx = db.transaction(STORE_NAME, 'readwrite');
                        objectStore = tx.objectStore(STORE_NAME);
                        _context3.next = 8;
                        return objectStore.put(heartbeatObject, computeKey(app));

                    case 8:
                        return _context3.abrupt('return', tx.complete);

                    case 11:
                        _context3.prev = 11;
                        _context3.t0 = _context3['catch'](0);
                        throw ERROR_FACTORY.create("storage-set" /* STORAGE_WRITE */, {
                            originalErrorMessage: _context3.t0.message
                        });

                    case 14:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this, [[0, 11]]);
    }));

    return function writeHeartbeatsToIndexedDB(_x6, _x7) {
        return _ref3.apply(this, arguments);
    };
}();

var _util = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/util/dist/index.esm2017.js");

Object.defineProperty(exports, 'FirebaseError', {
    enumerable: true,
    get: function get() {
        return _util.FirebaseError;
    }
});

var _component = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/component/dist/esm/index.esm2017.js");

var _logger = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/logger/dist/esm/index.esm2017.js");

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PlatformLoggerServiceImpl = function () {
    function PlatformLoggerServiceImpl(container) {
        _classCallCheck(this, PlatformLoggerServiceImpl);

        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.


    _createClass(PlatformLoggerServiceImpl, [{
        key: 'getPlatformInfoString',
        value: function getPlatformInfoString() {
            var providers = this.container.getProviders();
            // Loop through providers and get library/version pairs from any that are
            // version components.
            return providers.map(function (provider) {
                if (isVersionServiceProvider(provider)) {
                    var service = provider.getImmediate();
                    return service.library + '/' + service.version;
                } else {
                    return null;
                }
            }).filter(function (logString) {
                return logString;
            }).join(' ');
        }
    }]);

    return PlatformLoggerServiceImpl;
}();
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */


function isVersionServiceProvider(provider) {
    var component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* VERSION */;
}

var name$o = "@firebase/app";
var version$1 = "0.7.21";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var logger = new _logger.Logger('@firebase/app');

var name$n = "@firebase/app-compat";

var name$m = "@firebase/analytics-compat";

var name$l = "@firebase/analytics";

var name$k = "@firebase/app-check-compat";

var name$j = "@firebase/app-check";

var name$i = "@firebase/auth";

var name$h = "@firebase/auth-compat";

var name$g = "@firebase/database";

var name$f = "@firebase/database-compat";

var name$e = "@firebase/functions";

var name$d = "@firebase/functions-compat";

var name$c = "@firebase/installations";

var name$b = "@firebase/installations-compat";

var name$a = "@firebase/messaging";

var name$9 = "@firebase/messaging-compat";

var name$8 = "@firebase/performance";

var name$7 = "@firebase/performance-compat";

var name$6 = "@firebase/remote-config";

var name$5 = "@firebase/remote-config-compat";

var name$4 = "@firebase/storage";

var name$3 = "@firebase/storage-compat";

var name$2 = "@firebase/firestore";

var name$1 = "@firebase/firestore-compat";

var name = "firebase";
var version = "9.6.11";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The default app name
 *
 * @internal
 */
var DEFAULT_ENTRY_NAME = '[DEFAULT]';
var PLATFORM_LOG_STRING = (_PLATFORM_LOG_STRING = {}, _defineProperty(_PLATFORM_LOG_STRING, name$o, 'fire-core'), _defineProperty(_PLATFORM_LOG_STRING, name$n, 'fire-core-compat'), _defineProperty(_PLATFORM_LOG_STRING, name$l, 'fire-analytics'), _defineProperty(_PLATFORM_LOG_STRING, name$m, 'fire-analytics-compat'), _defineProperty(_PLATFORM_LOG_STRING, name$j, 'fire-app-check'), _defineProperty(_PLATFORM_LOG_STRING, name$k, 'fire-app-check-compat'), _defineProperty(_PLATFORM_LOG_STRING, name$i, 'fire-auth'), _defineProperty(_PLATFORM_LOG_STRING, name$h, 'fire-auth-compat'), _defineProperty(_PLATFORM_LOG_STRING, name$g, 'fire-rtdb'), _defineProperty(_PLATFORM_LOG_STRING, name$f, 'fire-rtdb-compat'), _defineProperty(_PLATFORM_LOG_STRING, name$e, 'fire-fn'), _defineProperty(_PLATFORM_LOG_STRING, name$d, 'fire-fn-compat'), _defineProperty(_PLATFORM_LOG_STRING, name$c, 'fire-iid'), _defineProperty(_PLATFORM_LOG_STRING, name$b, 'fire-iid-compat'), _defineProperty(_PLATFORM_LOG_STRING, name$a, 'fire-fcm'), _defineProperty(_PLATFORM_LOG_STRING, name$9, 'fire-fcm-compat'), _defineProperty(_PLATFORM_LOG_STRING, name$8, 'fire-perf'), _defineProperty(_PLATFORM_LOG_STRING, name$7, 'fire-perf-compat'), _defineProperty(_PLATFORM_LOG_STRING, name$6, 'fire-rc'), _defineProperty(_PLATFORM_LOG_STRING, name$5, 'fire-rc-compat'), _defineProperty(_PLATFORM_LOG_STRING, name$4, 'fire-gcs'), _defineProperty(_PLATFORM_LOG_STRING, name$3, 'fire-gcs-compat'), _defineProperty(_PLATFORM_LOG_STRING, name$2, 'fire-fst'), _defineProperty(_PLATFORM_LOG_STRING, name$1, 'fire-fst-compat'), _defineProperty(_PLATFORM_LOG_STRING, 'fire-js', 'fire-js'), _defineProperty(_PLATFORM_LOG_STRING, name, 'fire-js-all'), _PLATFORM_LOG_STRING);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @internal
 */
var _apps = new Map();
/**
 * Registered components.
 *
 * @internal
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var _components = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */
function _addComponent(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        logger.debug('Component ' + component.name + ' failed to register with FirebaseApp ' + app.name, e);
    }
}
/**
 *
 * @internal
 */
function _addOrOverwriteComponent(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */
function _registerComponent(component) {
    var componentName = component.name;
    if (_components.has(componentName)) {
        logger.debug('There were multiple attempts to register component ' + componentName + '.');
        return false;
    }
    _components.set(componentName, component);
    // add the component to existing app instances
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = _apps.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var app = _step.value;

            _addComponent(app, component);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */
function _getProvider(app, name) {
    var heartbeatController = app.container.getProvider('heartbeat').getImmediate({ optional: true });
    if (heartbeatController) {
        void heartbeatController.triggerHeartbeat();
    }
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */
function _removeServiceInstance(app, name) {
    var instanceIdentifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_ENTRY_NAME;

    _getProvider(app, name).clearInstance(instanceIdentifier);
}
/**
 * Test only
 *
 * @internal
 */
function _clearComponents() {
    _components.clear();
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ERRORS = (_ERRORS = {}, _defineProperty(_ERRORS, "no-app" /* NO_APP */, "No Firebase App '{$appName}' has been created - " + 'call Firebase App.initializeApp()'), _defineProperty(_ERRORS, "bad-app-name" /* BAD_APP_NAME */, "Illegal App name: '{$appName}"), _defineProperty(_ERRORS, "duplicate-app" /* DUPLICATE_APP */, "Firebase App named '{$appName}' already exists with different options or config"), _defineProperty(_ERRORS, "app-deleted" /* APP_DELETED */, "Firebase App named '{$appName}' already deleted"), _defineProperty(_ERRORS, "invalid-app-argument" /* INVALID_APP_ARGUMENT */, 'firebase.{$appName}() takes either no argument or a ' + 'Firebase App instance.'), _defineProperty(_ERRORS, "invalid-log-argument" /* INVALID_LOG_ARGUMENT */, 'First argument to `onLog` must be null or a function.'), _defineProperty(_ERRORS, "storage-open" /* STORAGE_OPEN */, 'Error thrown when opening storage. Original error: {$originalErrorMessage}.'), _defineProperty(_ERRORS, "storage-get" /* STORAGE_GET */, 'Error thrown when reading from storage. Original error: {$originalErrorMessage}.'), _defineProperty(_ERRORS, "storage-set" /* STORAGE_WRITE */, 'Error thrown when writing to storage. Original error: {$originalErrorMessage}.'), _defineProperty(_ERRORS, "storage-delete" /* STORAGE_DELETE */, 'Error thrown when deleting from storage. Original error: {$originalErrorMessage}.'), _ERRORS);
var ERROR_FACTORY = new _util.ErrorFactory('app', 'Firebase', ERRORS);

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var FirebaseAppImpl = function () {
    function FirebaseAppImpl(options, config, container) {
        var _this = this;

        _classCallCheck(this, FirebaseAppImpl);

        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new _component.Component('app', function () {
            return _this;
        }, "PUBLIC" /* PUBLIC */));
    }

    _createClass(FirebaseAppImpl, [{
        key: 'checkDestroyed',

        /**
         * This function will throw an Error if the App has already been deleted -
         * use before performing API actions on the App.
         */
        value: function checkDestroyed() {
            if (this.isDeleted) {
                throw ERROR_FACTORY.create("app-deleted" /* APP_DELETED */, { appName: this._name });
            }
        }
    }, {
        key: 'automaticDataCollectionEnabled',
        get: function get() {
            this.checkDestroyed();
            return this._automaticDataCollectionEnabled;
        },
        set: function set(val) {
            this.checkDestroyed();
            this._automaticDataCollectionEnabled = val;
        }
    }, {
        key: 'name',
        get: function get() {
            this.checkDestroyed();
            return this._name;
        }
    }, {
        key: 'options',
        get: function get() {
            this.checkDestroyed();
            return this._options;
        }
    }, {
        key: 'config',
        get: function get() {
            this.checkDestroyed();
            return this._config;
        }
    }, {
        key: 'container',
        get: function get() {
            return this._container;
        }
    }, {
        key: 'isDeleted',
        get: function get() {
            return this._isDeleted;
        },
        set: function set(val) {
            this._isDeleted = val;
        }
    }]);

    return FirebaseAppImpl;
}();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The current SDK version.
 *
 * @public
 */


var SDK_VERSION = version;
function initializeApp(options) {
    var rawConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if ((typeof rawConfig === 'undefined' ? 'undefined' : _typeof(rawConfig)) !== 'object') {
        var _name = rawConfig;
        rawConfig = { name: _name };
    }
    var config = Object.assign({ name: DEFAULT_ENTRY_NAME, automaticDataCollectionEnabled: false }, rawConfig);
    var name = config.name;
    if (typeof name !== 'string' || !name) {
        throw ERROR_FACTORY.create("bad-app-name" /* BAD_APP_NAME */, {
            appName: String(name)
        });
    }
    var existingApp = _apps.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, _util.deepEqual)(options, existingApp.options) && (0, _util.deepEqual)(config, existingApp.config)) {
            return existingApp;
        } else {
            throw ERROR_FACTORY.create("duplicate-app" /* DUPLICATE_APP */, { appName: name });
        }
    }
    var container = new _component.ComponentContainer(name);
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = _components.values()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var component = _step2.value;

            container.addComponent(component);
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    var newApp = new FirebaseAppImpl(options, config, container);
    _apps.set(name, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */
function getApp() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ENTRY_NAME;

    var app = _apps.get(name);
    if (!app) {
        throw ERROR_FACTORY.create("no-app" /* NO_APP */, { appName: name });
    }
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */
function getApps() {
    return Array.from(_apps.values());
}function registerVersion(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    var library = (_a = PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) {
        library += '-' + variant;
    }
    var libraryMismatch = library.match(/\s|\//);
    var versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        var warning = ['Unable to register library "' + library + '" with version "' + version + '":'];
        if (libraryMismatch) {
            warning.push('library name "' + library + '" contains illegal characters (whitespace or "/")');
        }
        if (libraryMismatch && versionMismatch) {
            warning.push('and');
        }
        if (versionMismatch) {
            warning.push('version name "' + version + '" contains illegal characters (whitespace or "/")');
        }
        logger.warn(warning.join(' '));
        return;
    }
    _registerComponent(new _component.Component(library + '-version', function () {
        return { library: library, version: version };
    }, "VERSION" /* VERSION */));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */
function onLog(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') {
        throw ERROR_FACTORY.create("invalid-log-argument" /* INVALID_LOG_ARGUMENT */);
    }
    (0, _logger.setUserLogHandler)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */
function setLogLevel(logLevel) {
    (0, _logger.setLogLevel)(logLevel);
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DB_NAME = 'firebase-heartbeat-database';
var DB_VERSION = 1;
var STORE_NAME = 'firebase-heartbeat-store';
var dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = (0, _util.openDB)(DB_NAME, DB_VERSION, function (db, oldVersion) {
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch (oldVersion) {
                case 0:
                    db.createObjectStore(STORE_NAME);
            }
        }).catch(function (e) {
            throw ERROR_FACTORY.create("storage-open" /* STORAGE_OPEN */, {
                originalErrorMessage: e.message
            });
        });
    }
    return dbPromise;
}

function computeKey(app) {
    return app.name + '!' + app.options.appId;
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MAX_HEADER_BYTES = 1024;
// 30 days
var STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 30 * 24 * 60 * 60 * 1000;

var HeartbeatServiceImpl = function () {
    function HeartbeatServiceImpl(container) {
        var _this2 = this;

        _classCallCheck(this, HeartbeatServiceImpl);

        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */
        this._heartbeatsCache = null;
        var app = this.container.getProvider('app').getImmediate();
        this._storage = new HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then(function (result) {
            _this2._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */


    _createClass(HeartbeatServiceImpl, [{
        key: 'triggerHeartbeat',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var platformLogger, agent, date;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                platformLogger = this.container.getProvider('platform-logger').getImmediate();
                                // This is the "Firebase user agent" string from the platform logger
                                // service, not the browser user agent.

                                agent = platformLogger.getPlatformInfoString();
                                date = getUTCDateString();

                                if (!(this._heartbeatsCache === null)) {
                                    _context4.next = 7;
                                    break;
                                }

                                _context4.next = 6;
                                return this._heartbeatsCachePromise;

                            case 6:
                                this._heartbeatsCache = _context4.sent;

                            case 7:
                                if (!(this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some(function (singleDateHeartbeat) {
                                    return singleDateHeartbeat.date === date;
                                }))) {
                                    _context4.next = 11;
                                    break;
                                }

                                return _context4.abrupt('return');

                            case 11:
                                // There is no entry for this date. Create one.
                                this._heartbeatsCache.heartbeats.push({ date: date, agent: agent });

                            case 12:
                                // Remove entries older than 30 days.
                                this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter(function (singleDateHeartbeat) {
                                    var hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                                    var now = Date.now();
                                    return now - hbTimestamp <= STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
                                });
                                return _context4.abrupt('return', this._storage.overwrite(this._heartbeatsCache));

                            case 14:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function triggerHeartbeat() {
                return _ref4.apply(this, arguments);
            }

            return triggerHeartbeat;
        }()
        /**
         * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
         * It also clears all heartbeats from memory as well as in IndexedDB.
         *
         * NOTE: Consuming product SDKs should not send the header if this method
         * returns an empty string.
         */

    }, {
        key: 'getHeartbeatsHeader',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var date, _extractHeartbeatsFor, heartbeatsToSend, unsentEntries, headerString;

                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                if (!(this._heartbeatsCache === null)) {
                                    _context5.next = 3;
                                    break;
                                }

                                _context5.next = 3;
                                return this._heartbeatsCachePromise;

                            case 3:
                                if (!(this._heartbeatsCache === null || this._heartbeatsCache.heartbeats.length === 0)) {
                                    _context5.next = 5;
                                    break;
                                }

                                return _context5.abrupt('return', '');

                            case 5:
                                date = getUTCDateString();
                                // Extract as many heartbeats from the cache as will fit under the size limit.

                                _extractHeartbeatsFor = extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats), heartbeatsToSend = _extractHeartbeatsFor.heartbeatsToSend, unsentEntries = _extractHeartbeatsFor.unsentEntries;
                                headerString = (0, _util.base64urlEncodeWithoutPadding)(JSON.stringify({ version: 2, heartbeats: heartbeatsToSend }));
                                // Store last sent date to prevent another being logged/sent for the same day.

                                this._heartbeatsCache.lastSentHeartbeatDate = date;

                                if (!(unsentEntries.length > 0)) {
                                    _context5.next = 15;
                                    break;
                                }

                                // Store any unsent entries if they exist.
                                this._heartbeatsCache.heartbeats = unsentEntries;
                                // This seems more likely than emptying the array (below) to lead to some odd state
                                // since the cache isn't empty and this will be called again on the next request,
                                // and is probably safest if we await it.
                                _context5.next = 13;
                                return this._storage.overwrite(this._heartbeatsCache);

                            case 13:
                                _context5.next = 17;
                                break;

                            case 15:
                                this._heartbeatsCache.heartbeats = [];
                                // Do not wait for this, to reduce latency.
                                void this._storage.overwrite(this._heartbeatsCache);

                            case 17:
                                return _context5.abrupt('return', headerString);

                            case 18:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function getHeartbeatsHeader() {
                return _ref5.apply(this, arguments);
            }

            return getHeartbeatsHeader;
        }()
    }]);

    return HeartbeatServiceImpl;
}();

function getUTCDateString() {
    var today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function extractHeartbeatsForHeader(heartbeatsCache) {
    var maxSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MAX_HEADER_BYTES;

    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    var heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    var unsentEntries = heartbeatsCache.slice();

    var _loop = function _loop(singleDateHeartbeat) {
        // Look for an existing entry with the same user agent.
        var heartbeatEntry = heartbeatsToSend.find(function (hb) {
            return hb.agent === singleDateHeartbeat.agent;
        });
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [singleDateHeartbeat.date]
            });
            if (countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                return 'break';
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if (countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                return 'break';
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    };

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = heartbeatsCache[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var singleDateHeartbeat = _step3.value;

            var _ret = _loop(singleDateHeartbeat);

            if (_ret === 'break') break;
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}

var HeartbeatStorageImpl = function () {
    function HeartbeatStorageImpl(app) {
        _classCallCheck(this, HeartbeatStorageImpl);

        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }

    _createClass(HeartbeatStorageImpl, [{
        key: 'runIndexedDBEnvironmentCheck',
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if ((0, _util.isIndexedDBAvailable)()) {
                                    _context6.next = 4;
                                    break;
                                }

                                return _context6.abrupt('return', false);

                            case 4:
                                return _context6.abrupt('return', (0, _util.validateIndexedDBOpenable)().then(function () {
                                    return true;
                                }).catch(function () {
                                    return false;
                                }));

                            case 5:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function runIndexedDBEnvironmentCheck() {
                return _ref6.apply(this, arguments);
            }

            return runIndexedDBEnvironmentCheck;
        }()
        /**
         * Read all heartbeats.
         */

    }, {
        key: 'read',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var canUseIndexedDB, idbHeartbeatObject;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.next = 2;
                                return this._canUseIndexedDBPromise;

                            case 2:
                                canUseIndexedDB = _context7.sent;

                                if (canUseIndexedDB) {
                                    _context7.next = 7;
                                    break;
                                }

                                return _context7.abrupt('return', { heartbeats: [] });

                            case 7:
                                _context7.next = 9;
                                return readHeartbeatsFromIndexedDB(this.app);

                            case 9:
                                idbHeartbeatObject = _context7.sent;
                                return _context7.abrupt('return', idbHeartbeatObject || { heartbeats: [] });

                            case 11:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function read() {
                return _ref7.apply(this, arguments);
            }

            return read;
        }()
        // overwrite the storage with the provided heartbeats

    }, {
        key: 'overwrite',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(heartbeatsObject) {
                var _a, canUseIndexedDB, existingHeartbeatsObject;

                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.next = 2;
                                return this._canUseIndexedDBPromise;

                            case 2:
                                canUseIndexedDB = _context8.sent;

                                if (canUseIndexedDB) {
                                    _context8.next = 7;
                                    break;
                                }

                                return _context8.abrupt('return');

                            case 7:
                                _context8.next = 9;
                                return this.read();

                            case 9:
                                existingHeartbeatsObject = _context8.sent;
                                return _context8.abrupt('return', writeHeartbeatsToIndexedDB(this.app, {
                                    lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                                    heartbeats: heartbeatsObject.heartbeats
                                }));

                            case 11:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function overwrite(_x9) {
                return _ref8.apply(this, arguments);
            }

            return overwrite;
        }()
        // add heartbeats

    }, {
        key: 'add',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(heartbeatsObject) {
                var _a, canUseIndexedDB, existingHeartbeatsObject;

                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this._canUseIndexedDBPromise;

                            case 2:
                                canUseIndexedDB = _context9.sent;

                                if (canUseIndexedDB) {
                                    _context9.next = 7;
                                    break;
                                }

                                return _context9.abrupt('return');

                            case 7:
                                _context9.next = 9;
                                return this.read();

                            case 9:
                                existingHeartbeatsObject = _context9.sent;
                                return _context9.abrupt('return', writeHeartbeatsToIndexedDB(this.app, {
                                    lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                                    heartbeats: [].concat(_toConsumableArray(existingHeartbeatsObject.heartbeats), _toConsumableArray(heartbeatsObject.heartbeats))
                                }));

                            case 11:
                            case 'end':
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function add(_x10) {
                return _ref9.apply(this, arguments);
            }

            return add;
        }()
    }]);

    return HeartbeatStorageImpl;
}();
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */


function countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, _util.base64urlEncodeWithoutPadding)(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: heartbeatsCache })).length;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerCoreComponents(variant) {
    _registerComponent(new _component.Component('platform-logger', function (container) {
        return new PlatformLoggerServiceImpl(container);
    }, "PRIVATE" /* PRIVATE */));
    _registerComponent(new _component.Component('heartbeat', function (container) {
        return new HeartbeatServiceImpl(container);
    }, "PRIVATE" /* PRIVATE */));
    // Register `app` package.
    registerVersion(name$o, version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    registerVersion(name$o, version$1, 'esm2017');
    // Register platform SDK identifier (no version).
    registerVersion('fire-js', '');
}

/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */
registerCoreComponents('');

exports.SDK_VERSION = SDK_VERSION;
exports._DEFAULT_ENTRY_NAME = DEFAULT_ENTRY_NAME;
exports._addComponent = _addComponent;
exports._addOrOverwriteComponent = _addOrOverwriteComponent;
exports._apps = _apps;
exports._clearComponents = _clearComponents;
exports._components = _components;
exports._getProvider = _getProvider;
exports._registerComponent = _registerComponent;
exports._removeServiceInstance = _removeServiceInstance;
exports.deleteApp = deleteApp;
exports.getApp = getApp;
exports.getApps = getApps;
exports.initializeApp = initializeApp;
exports.onLog = onLog;
exports.registerVersion = registerVersion;
exports.setLogLevel = setLogLevel;
//# sourceMappingURL=index.esm2017.js.map

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/component/dist/esm/index.esm2017.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Provider = exports.ComponentContainer = exports.Component = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/util/dist/index.esm2017.js");

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */
var Component = function () {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */
    function Component(name, instanceFactory, type) {
        _classCallCheck(this, Component);

        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */
        this.serviceProps = {};
        this.instantiationMode = "LAZY" /* LAZY */;
        this.onInstanceCreated = null;
    }

    _createClass(Component, [{
        key: 'setInstantiationMode',
        value: function setInstantiationMode(mode) {
            this.instantiationMode = mode;
            return this;
        }
    }, {
        key: 'setMultipleInstances',
        value: function setMultipleInstances(multipleInstances) {
            this.multipleInstances = multipleInstances;
            return this;
        }
    }, {
        key: 'setServiceProps',
        value: function setServiceProps(props) {
            this.serviceProps = props;
            return this;
        }
    }, {
        key: 'setInstanceCreatedCallback',
        value: function setInstanceCreatedCallback(callback) {
            this.onInstanceCreated = callback;
            return this;
        }
    }]);

    return Component;
}();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var DEFAULT_ENTRY_NAME = '[DEFAULT]';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */

var Provider = function () {
    function Provider(name, container) {
        _classCallCheck(this, Provider);

        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */


    _createClass(Provider, [{
        key: 'get',
        value: function get(identifier) {
            // if multipleInstances is not supported, use the default name
            var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
            if (!this.instancesDeferred.has(normalizedIdentifier)) {
                var deferred = new _util.Deferred();
                this.instancesDeferred.set(normalizedIdentifier, deferred);
                if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) {
                    // initialize the service if it can be auto-initialized
                    try {
                        var instance = this.getOrInitializeService({
                            instanceIdentifier: normalizedIdentifier
                        });
                        if (instance) {
                            deferred.resolve(instance);
                        }
                    } catch (e) {
                        // when the instance factory throws an exception during get(), it should not cause
                        // a fatal error. We just return the unresolved promise in this case.
                    }
                }
            }
            return this.instancesDeferred.get(normalizedIdentifier).promise;
        }
    }, {
        key: 'getImmediate',
        value: function getImmediate(options) {
            var _a;
            // if multipleInstances is not supported, use the default name
            var normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
            var optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) {
                try {
                    return this.getOrInitializeService({
                        instanceIdentifier: normalizedIdentifier
                    });
                } catch (e) {
                    if (optional) {
                        return null;
                    } else {
                        throw e;
                    }
                }
            } else {
                // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
                if (optional) {
                    return null;
                } else {
                    throw Error('Service ' + this.name + ' is not available');
                }
            }
        }
    }, {
        key: 'getComponent',
        value: function getComponent() {
            return this.component;
        }
    }, {
        key: 'setComponent',
        value: function setComponent(component) {
            if (component.name !== this.name) {
                throw Error('Mismatching Component ' + component.name + ' for Provider ' + this.name + '.');
            }
            if (this.component) {
                throw Error('Component for ' + this.name + ' has already been provided');
            }
            this.component = component;
            // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
            if (!this.shouldAutoInitialize()) {
                return;
            }
            // if the service is eager, initialize the default instance
            if (isComponentEager(component)) {
                try {
                    this.getOrInitializeService({ instanceIdentifier: DEFAULT_ENTRY_NAME });
                } catch (e) {
                    // when the instance factory for an eager Component throws an exception during the eager
                    // initialization, it should not cause a fatal error.
                    // TODO: Investigate if we need to make it configurable, because some component may want to cause
                    // a fatal error in this case?
                }
            }
            // Create service instances for the pending promises and resolve them
            // NOTE: if this.multipleInstances is false, only the default instance will be created
            // and all promises with resolve with it regardless of the identifier.
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.instancesDeferred.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ref = _step.value;

                    var _ref2 = _slicedToArray(_ref, 2);

                    var instanceIdentifier = _ref2[0];
                    var instanceDeferred = _ref2[1];

                    var normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                    try {
                        // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                        var instance = this.getOrInitializeService({
                            instanceIdentifier: normalizedIdentifier
                        });
                        instanceDeferred.resolve(instance);
                    } catch (e) {
                        // when the instance factory throws an exception, it should not cause
                        // a fatal error. We just leave the promise unresolved.
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: 'clearInstance',
        value: function clearInstance() {
            var identifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ENTRY_NAME;

            this.instancesDeferred.delete(identifier);
            this.instancesOptions.delete(identifier);
            this.instances.delete(identifier);
        }
        // app.delete() will call this method on every provider to delete the services
        // TODO: should we mark the provider as deleted?

    }, {
        key: 'delete',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var services;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                services = Array.from(this.instances.values());
                                _context.next = 3;
                                return Promise.all([].concat(_toConsumableArray(services.filter(function (service) {
                                    return 'INTERNAL' in service;
                                }) // legacy services
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                .map(function (service) {
                                    return service.INTERNAL.delete();
                                })), _toConsumableArray(services.filter(function (service) {
                                    return '_delete' in service;
                                }) // modularized services
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                .map(function (service) {
                                    return service._delete();
                                }))));

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function _delete() {
                return _ref3.apply(this, arguments);
            }

            return _delete;
        }()
    }, {
        key: 'isComponentSet',
        value: function isComponentSet() {
            return this.component != null;
        }
    }, {
        key: 'isInitialized',
        value: function isInitialized() {
            var identifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ENTRY_NAME;

            return this.instances.has(identifier);
        }
    }, {
        key: 'getOptions',
        value: function getOptions() {
            var identifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ENTRY_NAME;

            return this.instancesOptions.get(identifier) || {};
        }
    }, {
        key: 'initialize',
        value: function initialize() {
            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var _opts$options = opts.options,
                options = _opts$options === undefined ? {} : _opts$options;

            var normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
            if (this.isInitialized(normalizedIdentifier)) {
                throw Error(this.name + '(' + normalizedIdentifier + ') has already been initialized');
            }
            if (!this.isComponentSet()) {
                throw Error('Component ' + this.name + ' has not been registered yet');
            }
            var instance = this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier,
                options: options
            });
            // resolve any pending promise waiting for the service instance
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this.instancesDeferred.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var _ref4 = _step2.value;

                    var _ref5 = _slicedToArray(_ref4, 2);

                    var instanceIdentifier = _ref5[0];
                    var instanceDeferred = _ref5[1];

                    var normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
                    if (normalizedIdentifier === normalizedDeferredIdentifier) {
                        instanceDeferred.resolve(instance);
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return instance;
        }
        /**
         *
         * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
         * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
         *
         * @param identifier An optional instance identifier
         * @returns a function to unregister the callback
         */

    }, {
        key: 'onInit',
        value: function onInit(callback, identifier) {
            var _a;
            var normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
            var existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
            existingCallbacks.add(callback);
            this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
            var existingInstance = this.instances.get(normalizedIdentifier);
            if (existingInstance) {
                callback(existingInstance, normalizedIdentifier);
            }
            return function () {
                existingCallbacks.delete(callback);
            };
        }
        /**
         * Invoke onInit callbacks synchronously
         * @param instance the service instance`
         */

    }, {
        key: 'invokeOnInitCallbacks',
        value: function invokeOnInitCallbacks(instance, identifier) {
            var callbacks = this.onInitCallbacks.get(identifier);
            if (!callbacks) {
                return;
            }
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                for (var _iterator3 = callbacks[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var callback = _step3.value;

                    try {
                        callback(instance, identifier);
                    } catch (_a) {
                        // ignore errors in the onInit callback
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    }, {
        key: 'getOrInitializeService',
        value: function getOrInitializeService(_ref6) {
            var instanceIdentifier = _ref6.instanceIdentifier,
                _ref6$options = _ref6.options,
                options = _ref6$options === undefined ? {} : _ref6$options;

            var instance = this.instances.get(instanceIdentifier);
            if (!instance && this.component) {
                instance = this.component.instanceFactory(this.container, {
                    instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
                    options: options
                });
                this.instances.set(instanceIdentifier, instance);
                this.instancesOptions.set(instanceIdentifier, options);
                /**
                 * Invoke onInit listeners.
                 * Note this.component.onInstanceCreated is different, which is used by the component creator,
                 * while onInit listeners are registered by consumers of the provider.
                 */
                this.invokeOnInitCallbacks(instance, instanceIdentifier);
                /**
                 * Order is important
                 * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
                 * makes `isInitialized()` return true.
                 */
                if (this.component.onInstanceCreated) {
                    try {
                        this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
                    } catch (_a) {
                        // ignore errors in the onInstanceCreatedCallback
                    }
                }
            }
            return instance || null;
        }
    }, {
        key: 'normalizeInstanceIdentifier',
        value: function normalizeInstanceIdentifier() {
            var identifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_ENTRY_NAME;

            if (this.component) {
                return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
            } else {
                return identifier; // assume multiple instances are supported before the component is provided.
            }
        }
    }, {
        key: 'shouldAutoInitialize',
        value: function shouldAutoInitialize() {
            return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* EXPLICIT */;
        }
    }]);

    return Provider;
}();
// undefined should be passed to the service factory for the default instance


function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* EAGER */;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */

var ComponentContainer = function () {
    function ComponentContainer(name) {
        _classCallCheck(this, ComponentContainer);

        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */


    _createClass(ComponentContainer, [{
        key: 'addComponent',
        value: function addComponent(component) {
            var provider = this.getProvider(component.name);
            if (provider.isComponentSet()) {
                throw new Error('Component ' + component.name + ' has already been registered with ' + this.name);
            }
            provider.setComponent(component);
        }
    }, {
        key: 'addOrOverwriteComponent',
        value: function addOrOverwriteComponent(component) {
            var provider = this.getProvider(component.name);
            if (provider.isComponentSet()) {
                // delete the existing provider from the container, so we can register the new component
                this.providers.delete(component.name);
            }
            this.addComponent(component);
        }
        /**
         * getProvider provides a type safe interface where it can only be called with a field name
         * present in NameServiceMapping interface.
         *
         * Firebase SDKs providing services should extend NameServiceMapping interface to register
         * themselves.
         */

    }, {
        key: 'getProvider',
        value: function getProvider(name) {
            if (this.providers.has(name)) {
                return this.providers.get(name);
            }
            // create a Provider for a service that hasn't registered with Firebase
            var provider = new Provider(name, this);
            this.providers.set(name, provider);
            return provider;
        }
    }, {
        key: 'getProviders',
        value: function getProviders() {
            return Array.from(this.providers.values());
        }
    }]);

    return ComponentContainer;
}();

exports.Component = Component;
exports.ComponentContainer = ComponentContainer;
exports.Provider = Provider;
//# sourceMappingURL=index.esm2017.js.map

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/installations/dist/esm/index.esm2017.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onIdChange = exports.getToken = exports.getInstallations = exports.getId = exports.deleteInstallations = undefined;

var _ERROR_DESCRIPTION_MA;

var getErrorFromResponse = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(requestName, response) {
        var responseJson, errorData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return response.json();

                    case 2:
                        responseJson = _context.sent;
                        errorData = responseJson.error;
                        return _context.abrupt('return', ERROR_FACTORY.create("request-failed" /* REQUEST_FAILED */, {
                            requestName: requestName,
                            serverCode: errorData.code,
                            serverMessage: errorData.message,
                            serverStatus: errorData.status
                        }));

                    case 5:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getErrorFromResponse(_x, _x2) {
        return _ref2.apply(this, arguments);
    };
}();

/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */
var retryIfServerError = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(fn) {
        var result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return fn();

                    case 2:
                        result = _context2.sent;

                        if (!(result.status >= 500 && result.status < 600)) {
                            _context2.next = 5;
                            break;
                        }

                        return _context2.abrupt('return', fn());

                    case 5:
                        return _context2.abrupt('return', result);

                    case 6:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function retryIfServerError(_x3) {
        return _ref5.apply(this, arguments);
    };
}();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var createInstallationRequest = function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref6, _ref7) {
        var appConfig = _ref6.appConfig,
            heartbeatServiceProvider = _ref6.heartbeatServiceProvider;
        var fid = _ref7.fid;
        var endpoint, headers, heartbeatService, heartbeatsHeader, body, request, response, responseValue, registeredInstallationEntry;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        endpoint = getInstallationsEndpoint(appConfig);
                        headers = getHeaders(appConfig);
                        // If heartbeat service exists, add the heartbeat string to the header.

                        heartbeatService = heartbeatServiceProvider.getImmediate({
                            optional: true
                        });

                        if (!heartbeatService) {
                            _context3.next = 8;
                            break;
                        }

                        _context3.next = 6;
                        return heartbeatService.getHeartbeatsHeader();

                    case 6:
                        heartbeatsHeader = _context3.sent;

                        if (heartbeatsHeader) {
                            headers.append('x-firebase-client', heartbeatsHeader);
                        }

                    case 8:
                        body = {
                            fid: fid,
                            authVersion: INTERNAL_AUTH_VERSION,
                            appId: appConfig.appId,
                            sdkVersion: PACKAGE_VERSION
                        };
                        request = {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(body)
                        };
                        _context3.next = 12;
                        return retryIfServerError(function () {
                            return fetch(endpoint, request);
                        });

                    case 12:
                        response = _context3.sent;

                        if (!response.ok) {
                            _context3.next = 21;
                            break;
                        }

                        _context3.next = 16;
                        return response.json();

                    case 16:
                        responseValue = _context3.sent;
                        registeredInstallationEntry = {
                            fid: responseValue.fid || fid,
                            registrationStatus: 2 /* COMPLETED */
                            , refreshToken: responseValue.refreshToken,
                            authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
                        };
                        return _context3.abrupt('return', registeredInstallationEntry);

                    case 21:
                        _context3.next = 23;
                        return getErrorFromResponse('Create Installation', response);

                    case 23:
                        throw _context3.sent;

                    case 24:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function createInstallationRequest(_x4, _x5) {
        return _ref8.apply(this, arguments);
    };
}();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a promise that resolves after given time passes. */


/** Assigns or overwrites the record for the given key with the given value. */
var set = function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(appConfig, value) {
        var key, db, tx, objectStore, oldValue;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        key = getKey(appConfig);
                        _context4.next = 3;
                        return getDbPromise();

                    case 3:
                        db = _context4.sent;
                        tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                        objectStore = tx.objectStore(OBJECT_STORE_NAME);
                        _context4.next = 8;
                        return objectStore.get(key);

                    case 8:
                        oldValue = _context4.sent;
                        _context4.next = 11;
                        return objectStore.put(value, key);

                    case 11:
                        _context4.next = 13;
                        return tx.complete;

                    case 13:
                        if (!oldValue || oldValue.fid !== value.fid) {
                            fidChanged(appConfig, value.fid);
                        }
                        return _context4.abrupt('return', value);

                    case 15:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function set(_x6, _x7) {
        return _ref9.apply(this, arguments);
    };
}();
/** Removes record(s) from the objectStore that match the given key. */


var remove = function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(appConfig) {
        var key, db, tx;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        key = getKey(appConfig);
                        _context5.next = 3;
                        return getDbPromise();

                    case 3:
                        db = _context5.sent;
                        tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                        _context5.next = 7;
                        return tx.objectStore(OBJECT_STORE_NAME).delete(key);

                    case 7:
                        _context5.next = 9;
                        return tx.complete;

                    case 9:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function remove(_x8) {
        return _ref10.apply(this, arguments);
    };
}();
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */


var update = function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(appConfig, updateFn) {
        var key, db, tx, store, oldValue, newValue;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        key = getKey(appConfig);
                        _context6.next = 3;
                        return getDbPromise();

                    case 3:
                        db = _context6.sent;
                        tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
                        store = tx.objectStore(OBJECT_STORE_NAME);
                        _context6.next = 8;
                        return store.get(key);

                    case 8:
                        oldValue = _context6.sent;
                        newValue = updateFn(oldValue);

                        if (!(newValue === undefined)) {
                            _context6.next = 15;
                            break;
                        }

                        _context6.next = 13;
                        return store.delete(key);

                    case 13:
                        _context6.next = 17;
                        break;

                    case 15:
                        _context6.next = 17;
                        return store.put(newValue, key);

                    case 17:
                        _context6.next = 19;
                        return tx.complete;

                    case 19:
                        if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) {
                            fidChanged(appConfig, newValue.fid);
                        }
                        return _context6.abrupt('return', newValue);

                    case 21:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function update(_x9, _x10) {
        return _ref11.apply(this, arguments);
    };
}();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */


var getInstallationEntry = function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(installations) {
        var registrationPromise, installationEntry;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        registrationPromise = void 0;
                        _context7.next = 3;
                        return update(installations.appConfig, function (oldEntry) {
                            var installationEntry = updateOrCreateInstallationEntry(oldEntry);
                            var entryWithPromise = triggerRegistrationIfNecessary(installations, installationEntry);
                            registrationPromise = entryWithPromise.registrationPromise;
                            return entryWithPromise.installationEntry;
                        });

                    case 3:
                        installationEntry = _context7.sent;

                        if (!(installationEntry.fid === INVALID_FID)) {
                            _context7.next = 9;
                            break;
                        }

                        _context7.next = 7;
                        return registrationPromise;

                    case 7:
                        _context7.t0 = _context7.sent;
                        return _context7.abrupt('return', {
                            installationEntry: _context7.t0
                        });

                    case 9:
                        return _context7.abrupt('return', {
                            installationEntry: installationEntry,
                            registrationPromise: registrationPromise
                        });

                    case 10:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, this);
    }));

    return function getInstallationEntry(_x11) {
        return _ref12.apply(this, arguments);
    };
}();
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */


/** This will be executed only once for each new Firebase Installation. */
var registerInstallation = function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(installations, installationEntry) {
        var registeredInstallationEntry;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        _context8.prev = 0;
                        _context8.next = 3;
                        return createInstallationRequest(installations, installationEntry);

                    case 3:
                        registeredInstallationEntry = _context8.sent;
                        return _context8.abrupt('return', set(installations.appConfig, registeredInstallationEntry));

                    case 7:
                        _context8.prev = 7;
                        _context8.t0 = _context8['catch'](0);

                        if (!(isServerError(_context8.t0) && _context8.t0.customData.serverCode === 409)) {
                            _context8.next = 14;
                            break;
                        }

                        _context8.next = 12;
                        return remove(installations.appConfig);

                    case 12:
                        _context8.next = 16;
                        break;

                    case 14:
                        _context8.next = 16;
                        return set(installations.appConfig, {
                            fid: installationEntry.fid,
                            registrationStatus: 0 /* NOT_STARTED */
                        });

                    case 16:
                        throw _context8.t0;

                    case 17:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, this, [[0, 7]]);
    }));

    return function registerInstallation(_x12, _x13) {
        return _ref13.apply(this, arguments);
    };
}();
/** Call if FID registration is pending in another request. */


var waitUntilFidRegistration = function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(installations) {
        var entry, _ref15, installationEntry, registrationPromise;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        _context9.next = 2;
                        return updateInstallationRequest(installations.appConfig);

                    case 2:
                        entry = _context9.sent;

                    case 3:
                        if (!(entry.registrationStatus === 1 /* IN_PROGRESS */)) {
                            _context9.next = 11;
                            break;
                        }

                        _context9.next = 6;
                        return sleep(100);

                    case 6:
                        _context9.next = 8;
                        return updateInstallationRequest(installations.appConfig);

                    case 8:
                        entry = _context9.sent;
                        _context9.next = 3;
                        break;

                    case 11:
                        if (!(entry.registrationStatus === 0 /* NOT_STARTED */)) {
                            _context9.next = 22;
                            break;
                        }

                        _context9.next = 14;
                        return getInstallationEntry(installations);

                    case 14:
                        _ref15 = _context9.sent;
                        installationEntry = _ref15.installationEntry;
                        registrationPromise = _ref15.registrationPromise;

                        if (!registrationPromise) {
                            _context9.next = 21;
                            break;
                        }

                        return _context9.abrupt('return', registrationPromise);

                    case 21:
                        return _context9.abrupt('return', installationEntry);

                    case 22:
                        return _context9.abrupt('return', entry);

                    case 23:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee9, this);
    }));

    return function waitUntilFidRegistration(_x14) {
        return _ref14.apply(this, arguments);
    };
}();
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var generateAuthTokenRequest = function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(_ref16, installationEntry) {
        var appConfig = _ref16.appConfig,
            heartbeatServiceProvider = _ref16.heartbeatServiceProvider;
        var endpoint, headers, heartbeatService, heartbeatsHeader, body, request, response, responseValue, completedAuthToken;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
                switch (_context10.prev = _context10.next) {
                    case 0:
                        endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
                        headers = getHeadersWithAuth(appConfig, installationEntry);
                        // If heartbeat service exists, add the heartbeat string to the header.

                        heartbeatService = heartbeatServiceProvider.getImmediate({
                            optional: true
                        });

                        if (!heartbeatService) {
                            _context10.next = 8;
                            break;
                        }

                        _context10.next = 6;
                        return heartbeatService.getHeartbeatsHeader();

                    case 6:
                        heartbeatsHeader = _context10.sent;

                        if (heartbeatsHeader) {
                            headers.append('x-firebase-client', heartbeatsHeader);
                        }

                    case 8:
                        body = {
                            installation: {
                                sdkVersion: PACKAGE_VERSION,
                                appId: appConfig.appId
                            }
                        };
                        request = {
                            method: 'POST',
                            headers: headers,
                            body: JSON.stringify(body)
                        };
                        _context10.next = 12;
                        return retryIfServerError(function () {
                            return fetch(endpoint, request);
                        });

                    case 12:
                        response = _context10.sent;

                        if (!response.ok) {
                            _context10.next = 21;
                            break;
                        }

                        _context10.next = 16;
                        return response.json();

                    case 16:
                        responseValue = _context10.sent;
                        completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
                        return _context10.abrupt('return', completedAuthToken);

                    case 21:
                        _context10.next = 23;
                        return getErrorFromResponse('Generate Auth Token', response);

                    case 23:
                        throw _context10.sent;

                    case 24:
                    case 'end':
                        return _context10.stop();
                }
            }
        }, _callee10, this);
    }));

    return function generateAuthTokenRequest(_x15, _x16) {
        return _ref17.apply(this, arguments);
    };
}();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */
var refreshAuthToken = function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(installations) {
        var forceRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var tokenPromise, entry, authToken;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
                switch (_context11.prev = _context11.next) {
                    case 0:
                        tokenPromise = void 0;
                        _context11.next = 3;
                        return update(installations.appConfig, function (oldEntry) {
                            if (!isEntryRegistered(oldEntry)) {
                                throw ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */);
                            }
                            var oldAuthToken = oldEntry.authToken;
                            if (!forceRefresh && isAuthTokenValid(oldAuthToken)) {
                                // There is a valid token in the DB.
                                return oldEntry;
                            } else if (oldAuthToken.requestStatus === 1 /* IN_PROGRESS */) {
                                    // There already is a token request in progress.
                                    tokenPromise = waitUntilAuthTokenRequest(installations, forceRefresh);
                                    return oldEntry;
                                } else {
                                // No token or token expired.
                                if (!navigator.onLine) {
                                    throw ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */);
                                }
                                var inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
                                tokenPromise = fetchAuthTokenFromServer(installations, inProgressEntry);
                                return inProgressEntry;
                            }
                        });

                    case 3:
                        entry = _context11.sent;

                        if (!tokenPromise) {
                            _context11.next = 10;
                            break;
                        }

                        _context11.next = 7;
                        return tokenPromise;

                    case 7:
                        _context11.t0 = _context11.sent;
                        _context11.next = 11;
                        break;

                    case 10:
                        _context11.t0 = entry.authToken;

                    case 11:
                        authToken = _context11.t0;
                        return _context11.abrupt('return', authToken);

                    case 13:
                    case 'end':
                        return _context11.stop();
                }
            }
        }, _callee11, this);
    }));

    return function refreshAuthToken(_x18) {
        return _ref19.apply(this, arguments);
    };
}();
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */


var waitUntilAuthTokenRequest = function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(installations, forceRefresh) {
        var entry, authToken;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
                switch (_context12.prev = _context12.next) {
                    case 0:
                        _context12.next = 2;
                        return updateAuthTokenRequest(installations.appConfig);

                    case 2:
                        entry = _context12.sent;

                    case 3:
                        if (!(entry.authToken.requestStatus === 1 /* IN_PROGRESS */)) {
                            _context12.next = 11;
                            break;
                        }

                        _context12.next = 6;
                        return sleep(100);

                    case 6:
                        _context12.next = 8;
                        return updateAuthTokenRequest(installations.appConfig);

                    case 8:
                        entry = _context12.sent;
                        _context12.next = 3;
                        break;

                    case 11:
                        authToken = entry.authToken;

                        if (!(authToken.requestStatus === 0 /* NOT_STARTED */)) {
                            _context12.next = 16;
                            break;
                        }

                        return _context12.abrupt('return', refreshAuthToken(installations, forceRefresh));

                    case 16:
                        return _context12.abrupt('return', authToken);

                    case 17:
                    case 'end':
                        return _context12.stop();
                }
            }
        }, _callee12, this);
    }));

    return function waitUntilAuthTokenRequest(_x19, _x20) {
        return _ref20.apply(this, arguments);
    };
}();
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */


var fetchAuthTokenFromServer = function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(installations, installationEntry) {
        var authToken, updatedInstallationEntry, _updatedInstallationEntry;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
                switch (_context13.prev = _context13.next) {
                    case 0:
                        _context13.prev = 0;
                        _context13.next = 3;
                        return generateAuthTokenRequest(installations, installationEntry);

                    case 3:
                        authToken = _context13.sent;
                        updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), { authToken: authToken });
                        _context13.next = 7;
                        return set(installations.appConfig, updatedInstallationEntry);

                    case 7:
                        return _context13.abrupt('return', authToken);

                    case 10:
                        _context13.prev = 10;
                        _context13.t0 = _context13['catch'](0);

                        if (!(isServerError(_context13.t0) && (_context13.t0.customData.serverCode === 401 || _context13.t0.customData.serverCode === 404))) {
                            _context13.next = 17;
                            break;
                        }

                        _context13.next = 15;
                        return remove(installations.appConfig);

                    case 15:
                        _context13.next = 20;
                        break;

                    case 17:
                        _updatedInstallationEntry = Object.assign(Object.assign({}, installationEntry), { authToken: { requestStatus: 0 /* NOT_STARTED */ } });
                        _context13.next = 20;
                        return set(installations.appConfig, _updatedInstallationEntry);

                    case 20:
                        throw _context13.t0;

                    case 21:
                    case 'end':
                        return _context13.stop();
                }
            }
        }, _callee13, this, [[0, 10]]);
    }));

    return function fetchAuthTokenFromServer(_x21, _x22) {
        return _ref21.apply(this, arguments);
    };
}();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */
var _getId = function () {
    var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(installations) {
        var installationsImpl, _ref23, installationEntry, registrationPromise;

        return regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) {
                switch (_context14.prev = _context14.next) {
                    case 0:
                        installationsImpl = installations;
                        _context14.next = 3;
                        return getInstallationEntry(installationsImpl);

                    case 3:
                        _ref23 = _context14.sent;
                        installationEntry = _ref23.installationEntry;
                        registrationPromise = _ref23.registrationPromise;

                        if (registrationPromise) {
                            registrationPromise.catch(console.error);
                        } else {
                            // If the installation is already registered, update the authentication
                            // token if needed.
                            refreshAuthToken(installationsImpl).catch(console.error);
                        }
                        return _context14.abrupt('return', installationEntry.fid);

                    case 8:
                    case 'end':
                        return _context14.stop();
                }
            }
        }, _callee14, this);
    }));

    return function _getId(_x23) {
        return _ref22.apply(this, arguments);
    };
}();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */


var _getToken = function () {
    var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(installations) {
        var forceRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var installationsImpl, authToken;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
                switch (_context15.prev = _context15.next) {
                    case 0:
                        installationsImpl = installations;
                        _context15.next = 3;
                        return completeInstallationRegistration(installationsImpl);

                    case 3:
                        _context15.next = 5;
                        return refreshAuthToken(installationsImpl, forceRefresh);

                    case 5:
                        authToken = _context15.sent;
                        return _context15.abrupt('return', authToken.token);

                    case 7:
                    case 'end':
                        return _context15.stop();
                }
            }
        }, _callee15, this);
    }));

    return function _getToken(_x25) {
        return _ref24.apply(this, arguments);
    };
}();

var completeInstallationRegistration = function () {
    var _ref25 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(installations) {
        var _ref26, registrationPromise;

        return regeneratorRuntime.wrap(function _callee16$(_context16) {
            while (1) {
                switch (_context16.prev = _context16.next) {
                    case 0:
                        _context16.next = 2;
                        return getInstallationEntry(installations);

                    case 2:
                        _ref26 = _context16.sent;
                        registrationPromise = _ref26.registrationPromise;

                        if (!registrationPromise) {
                            _context16.next = 7;
                            break;
                        }

                        _context16.next = 7;
                        return registrationPromise;

                    case 7:
                    case 'end':
                        return _context16.stop();
                }
            }
        }, _callee16, this);
    }));

    return function completeInstallationRegistration(_x26) {
        return _ref25.apply(this, arguments);
    };
}();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var deleteInstallationRequest = function () {
    var _ref27 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(appConfig, installationEntry) {
        var endpoint, headers, request, response;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
            while (1) {
                switch (_context17.prev = _context17.next) {
                    case 0:
                        endpoint = getDeleteEndpoint(appConfig, installationEntry);
                        headers = getHeadersWithAuth(appConfig, installationEntry);
                        request = {
                            method: 'DELETE',
                            headers: headers
                        };
                        _context17.next = 5;
                        return retryIfServerError(function () {
                            return fetch(endpoint, request);
                        });

                    case 5:
                        response = _context17.sent;

                        if (response.ok) {
                            _context17.next = 10;
                            break;
                        }

                        _context17.next = 9;
                        return getErrorFromResponse('Delete Installation', response);

                    case 9:
                        throw _context17.sent;

                    case 10:
                    case 'end':
                        return _context17.stop();
                }
            }
        }, _callee17, this);
    }));

    return function deleteInstallationRequest(_x27, _x28) {
        return _ref27.apply(this, arguments);
    };
}();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */
var deleteInstallations = function () {
    var _ref29 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(installations) {
        var appConfig, entry;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
            while (1) {
                switch (_context18.prev = _context18.next) {
                    case 0:
                        appConfig = installations.appConfig;
                        _context18.next = 3;
                        return update(appConfig, function (oldEntry) {
                            if (oldEntry && oldEntry.registrationStatus === 0 /* NOT_STARTED */) {
                                    // Delete the unregistered entry without sending a deleteInstallation request.
                                    return undefined;
                                }
                            return oldEntry;
                        });

                    case 3:
                        entry = _context18.sent;

                        if (!entry) {
                            _context18.next = 18;
                            break;
                        }

                        if (!(entry.registrationStatus === 1 /* IN_PROGRESS */)) {
                            _context18.next = 9;
                            break;
                        }

                        throw ERROR_FACTORY.create("delete-pending-registration" /* DELETE_PENDING_REGISTRATION */);

                    case 9:
                        if (!(entry.registrationStatus === 2 /* COMPLETED */)) {
                            _context18.next = 18;
                            break;
                        }

                        if (navigator.onLine) {
                            _context18.next = 14;
                            break;
                        }

                        throw ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */);

                    case 14:
                        _context18.next = 16;
                        return deleteInstallationRequest(appConfig, entry);

                    case 16:
                        _context18.next = 18;
                        return remove(appConfig);

                    case 18:
                    case 'end':
                        return _context18.stop();
                }
            }
        }, _callee18, this);
    }));

    return function deleteInstallations(_x29) {
        return _ref29.apply(this, arguments);
    };
}();

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */


var _app = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/app/dist/esm/index.esm2017.js");

var _component = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/component/dist/esm/index.esm2017.js");

var _util = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/util/dist/index.esm2017.js");

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var name = "@firebase/installations";
var version = "0.5.8";

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PENDING_TIMEOUT_MS = 10000;
var PACKAGE_VERSION = 'w:' + version;
var INTERNAL_AUTH_VERSION = 'FIS_v2';
var INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
var TOKEN_EXPIRATION_BUFFER = 60 * 60 * 1000; // One hour
var SERVICE = 'installations';
var SERVICE_NAME = 'Installations';

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ERROR_DESCRIPTION_MAP = (_ERROR_DESCRIPTION_MA = {}, _defineProperty(_ERROR_DESCRIPTION_MA, "missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */, 'Missing App configuration value: "{$valueName}"'), _defineProperty(_ERROR_DESCRIPTION_MA, "not-registered" /* NOT_REGISTERED */, 'Firebase Installation is not registered.'), _defineProperty(_ERROR_DESCRIPTION_MA, "installation-not-found" /* INSTALLATION_NOT_FOUND */, 'Firebase Installation not found.'), _defineProperty(_ERROR_DESCRIPTION_MA, "request-failed" /* REQUEST_FAILED */, '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"'), _defineProperty(_ERROR_DESCRIPTION_MA, "app-offline" /* APP_OFFLINE */, 'Could not process request. Application offline.'), _defineProperty(_ERROR_DESCRIPTION_MA, "delete-pending-registration" /* DELETE_PENDING_REGISTRATION */, "Can't delete installation while there is a pending registration request."), _ERROR_DESCRIPTION_MA);
var ERROR_FACTORY = new _util.ErrorFactory(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */
function isServerError(error) {
    return error instanceof _util.FirebaseError && error.code.includes("request-failed" /* REQUEST_FAILED */);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getInstallationsEndpoint(_ref) {
    var projectId = _ref.projectId;

    return INSTALLATIONS_API_URL + '/projects/' + projectId + '/installations';
}
function extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* COMPLETED */
        , expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}

function getHeaders(_ref3) {
    var apiKey = _ref3.apiKey;

    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function getHeadersWithAuth(appConfig, _ref4) {
    var refreshToken = _ref4.refreshToken;

    var headers = getHeaders(appConfig);
    headers.append('Authorization', getAuthorizationHeader(refreshToken));
    return headers;
}
function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function getAuthorizationHeader(refreshToken) {
    return INTERNAL_AUTH_VERSION + ' ' + refreshToken;
}function sleep(ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function bufferToBase64UrlSafe(array) {
    var b64 = btoa(String.fromCharCode.apply(String, _toConsumableArray(array)));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
var INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */
function generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        var fidByteArray = new Uint8Array(17);
        var crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        var fid = encode(fidByteArray);
        return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
    } catch (_a) {
        // FID generation errored
        return INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */
function encode(fidByteArray) {
    var b64String = bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Returns a string key that can be used to identify the app. */
function getKey(appConfig) {
    return appConfig.appName + '!' + appConfig.appId;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */
function fidChanged(appConfig, fid) {
    var key = getKey(appConfig);
    callFidChangeCallbacks(key, fid);
    broadcastFidChange(key, fid);
}
function addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    getBroadcastChannel();
    var key = getKey(appConfig);
    var callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function removeCallback(appConfig, callback) {
    var key = getKey(appConfig);
    var callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        return;
    }
    callbackSet.delete(callback);
    if (callbackSet.size === 0) {
        fidChangeCallbacks.delete(key);
    }
    // Close broadcast channel if there are no more callbacks.
    closeBroadcastChannel();
}
function callFidChangeCallbacks(key, fid) {
    var callbacks = fidChangeCallbacks.get(key);
    if (!callbacks) {
        return;
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = callbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var callback = _step.value;

            callback(fid);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function broadcastFidChange(key, fid) {
    var channel = getBroadcastChannel();
    if (channel) {
        channel.postMessage({ key: key, fid: fid });
    }
    closeBroadcastChannel();
}
var broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */
function getBroadcastChannel() {
    if (!broadcastChannel && 'BroadcastChannel' in self) {
        broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        broadcastChannel.onmessage = function (e) {
            callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return broadcastChannel;
}
function closeBroadcastChannel() {
    if (fidChangeCallbacks.size === 0 && broadcastChannel) {
        broadcastChannel.close();
        broadcastChannel = null;
    }
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DATABASE_NAME = 'firebase-installations-database';
var DATABASE_VERSION = 1;
var OBJECT_STORE_NAME = 'firebase-installations-store';
var dbPromise = null;
function getDbPromise() {
    if (!dbPromise) {
        dbPromise = (0, _util.openDB)(DATABASE_NAME, DATABASE_VERSION, function (db, oldVersion) {
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch (oldVersion) {
                case 0:
                    db.createObjectStore(OBJECT_STORE_NAME);
            }
        });
    }
    return dbPromise;
}function updateOrCreateInstallationEntry(oldEntry) {
    var entry = oldEntry || {
        fid: generateFid(),
        registrationStatus: 0 /* NOT_STARTED */
    };
    return clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */
function triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* NOT_STARTED */) {
            if (!navigator.onLine) {
                // Registration required but app is offline.
                var registrationPromiseWithError = Promise.reject(ERROR_FACTORY.create("app-offline" /* APP_OFFLINE */));
                return {
                    installationEntry: installationEntry,
                    registrationPromise: registrationPromiseWithError
                };
            }
            // Try registering. Change status to IN_PROGRESS.
            var inProgressEntry = {
                fid: installationEntry.fid,
                registrationStatus: 1 /* IN_PROGRESS */
                , registrationTime: Date.now()
            };
            var registrationPromise = registerInstallation(installations, inProgressEntry);
            return { installationEntry: inProgressEntry, registrationPromise: registrationPromise };
        } else if (installationEntry.registrationStatus === 1 /* IN_PROGRESS */) {
            return {
                installationEntry: installationEntry,
                registrationPromise: waitUntilFidRegistration(installations)
            };
        } else {
        return { installationEntry: installationEntry };
    }
}function updateInstallationRequest(appConfig) {
    return update(appConfig, function (oldEntry) {
        if (!oldEntry) {
            throw ERROR_FACTORY.create("installation-not-found" /* INSTALLATION_NOT_FOUND */);
        }
        return clearTimedOutRequest(oldEntry);
    });
}
function clearTimedOutRequest(entry) {
    if (hasInstallationRequestTimedOut(entry)) {
        return {
            fid: entry.fid,
            registrationStatus: 0 /* NOT_STARTED */
        };
    }
    return entry;
}
function hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* IN_PROGRESS */ && installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now();
}
function getGenerateAuthTokenEndpoint(appConfig, _ref18) {
    var fid = _ref18.fid;

    return getInstallationsEndpoint(appConfig) + '/' + fid + '/authTokens:generate';
}function updateAuthTokenRequest(appConfig) {
    return update(appConfig, function (oldEntry) {
        if (!isEntryRegistered(oldEntry)) {
            throw ERROR_FACTORY.create("not-registered" /* NOT_REGISTERED */);
        }
        var oldAuthToken = oldEntry.authToken;
        if (hasAuthTokenRequestTimedOut(oldAuthToken)) {
            return Object.assign(Object.assign({}, oldEntry), { authToken: { requestStatus: 0 /* NOT_STARTED */ } });
        }
        return oldEntry;
    });
}

function isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* COMPLETED */;
}
function isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* COMPLETED */ && !isAuthTokenExpired(authToken);
}
function isAuthTokenExpired(authToken) {
    var now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */
function makeAuthTokenRequestInProgressEntry(oldEntry) {
    var inProgressAuthToken = {
        requestStatus: 1 /* IN_PROGRESS */
        , requestTime: Date.now()
    };
    return Object.assign(Object.assign({}, oldEntry), { authToken: inProgressAuthToken });
}
function hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* IN_PROGRESS */ && authToken.requestTime + PENDING_TIMEOUT_MS < Date.now();
}
function getDeleteEndpoint(appConfig, _ref28) {
    var fid = _ref28.fid;

    return getInstallationsEndpoint(appConfig) + '/' + fid;
}function onIdChange(installations, callback) {
    var appConfig = installations.appConfig;

    addCallback(appConfig, callback);
    return function () {
        removeCallback(appConfig, callback);
    };
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */
function getInstallations() {
    var app = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _app.getApp)();

    var installationsImpl = (0, _app._getProvider)(app, 'installations').getImmediate();
    return installationsImpl;
}

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function extractAppConfig(app) {
    if (!app || !app.options) {
        throw getMissingValueError('App Configuration');
    }
    if (!app.name) {
        throw getMissingValueError('App Name');
    }
    // Required app config keys
    var configKeys = ['projectId', 'apiKey', 'appId'];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = configKeys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var keyName = _step2.value;

            if (!app.options[keyName]) {
                throw getMissingValueError(keyName);
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function getMissingValueError(valueName) {
    return ERROR_FACTORY.create("missing-app-config-values" /* MISSING_APP_CONFIG_VALUES */, {
        valueName: valueName
    });
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var INSTALLATIONS_NAME = 'installations';
var INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
var publicFactory = function publicFactory(container) {
    var app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    var appConfig = extractAppConfig(app);
    var heartbeatServiceProvider = (0, _app._getProvider)(app, 'heartbeat');
    var installationsImpl = {
        app: app,
        appConfig: appConfig,
        heartbeatServiceProvider: heartbeatServiceProvider,
        _delete: function _delete() {
            return Promise.resolve();
        }
    };
    return installationsImpl;
};
var internalFactory = function internalFactory(container) {
    var app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    var installations = (0, _app._getProvider)(app, INSTALLATIONS_NAME).getImmediate();
    var installationsInternal = {
        getId: function getId() {
            return _getId(installations);
        },
        getToken: function getToken(forceRefresh) {
            return _getToken(installations, forceRefresh);
        }
    };
    return installationsInternal;
};
function registerInstallations() {
    (0, _app._registerComponent)(new _component.Component(INSTALLATIONS_NAME, publicFactory, "PUBLIC" /* PUBLIC */));
    (0, _app._registerComponent)(new _component.Component(INSTALLATIONS_NAME_INTERNAL, internalFactory, "PRIVATE" /* PRIVATE */));
}

/**
 * Firebase Installations
 *
 * @packageDocumentation
 */
registerInstallations();
(0, _app.registerVersion)(name, version);
// BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
(0, _app.registerVersion)(name, version, 'esm2017');

exports.deleteInstallations = deleteInstallations;
exports.getId = _getId;
exports.getInstallations = getInstallations;
exports.getToken = _getToken;
exports.onIdChange = onIdChange;
//# sourceMappingURL=index.esm2017.js.map

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/logger/dist/esm/index.esm2017.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ConsoleMethod;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A container for all of the Logger instances
 */
var instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
var levelStringToEnum = {
    'debug': LogLevel.DEBUG,
    'verbose': LogLevel.VERBOSE,
    'info': LogLevel.INFO,
    'warn': LogLevel.WARN,
    'error': LogLevel.ERROR,
    'silent': LogLevel.SILENT
};
/**
 * The default log level
 */
var defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */
var ConsoleMethod = (_ConsoleMethod = {}, _defineProperty(_ConsoleMethod, LogLevel.DEBUG, 'log'), _defineProperty(_ConsoleMethod, LogLevel.VERBOSE, 'log'), _defineProperty(_ConsoleMethod, LogLevel.INFO, 'info'), _defineProperty(_ConsoleMethod, LogLevel.WARN, 'warn'), _defineProperty(_ConsoleMethod, LogLevel.ERROR, 'error'), _ConsoleMethod);
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */
var defaultLogHandler = function defaultLogHandler(instance, logType) {
    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
    }

    if (logType < instance.logLevel) {
        return;
    }
    var now = new Date().toISOString();
    var method = ConsoleMethod[logType];
    if (method) {
        var _console;

        (_console = console)[method].apply(_console, ["[" + now + "]  " + instance.name + ":"].concat(args));
    } else {
        throw new Error("Attempted to log a message with an invalid logType (value: " + logType + ")");
    }
};

var Logger = function () {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */
    function Logger(name) {
        _classCallCheck(this, Logger);

        this.name = name;
        /**
         * The log level of the given Logger instance.
         */
        this._logLevel = defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */
        this._logHandler = defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */
        this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */
        instances.push(this);
    }

    _createClass(Logger, [{
        key: "setLogLevel",

        // Workaround for setter/getter having to be the same type.
        value: function setLogLevel(val) {
            this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
        }
    }, {
        key: "debug",

        /**
         * The functions below are all based on the `console` interface
         */
        value: function debug() {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            this._userLogHandler && this._userLogHandler.apply(this, [this, LogLevel.DEBUG].concat(args));
            this._logHandler.apply(this, [this, LogLevel.DEBUG].concat(args));
        }
    }, {
        key: "log",
        value: function log() {
            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            this._userLogHandler && this._userLogHandler.apply(this, [this, LogLevel.VERBOSE].concat(args));
            this._logHandler.apply(this, [this, LogLevel.VERBOSE].concat(args));
        }
    }, {
        key: "info",
        value: function info() {
            for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
            }

            this._userLogHandler && this._userLogHandler.apply(this, [this, LogLevel.INFO].concat(args));
            this._logHandler.apply(this, [this, LogLevel.INFO].concat(args));
        }
    }, {
        key: "warn",
        value: function warn() {
            for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                args[_key5] = arguments[_key5];
            }

            this._userLogHandler && this._userLogHandler.apply(this, [this, LogLevel.WARN].concat(args));
            this._logHandler.apply(this, [this, LogLevel.WARN].concat(args));
        }
    }, {
        key: "error",
        value: function error() {
            for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                args[_key6] = arguments[_key6];
            }

            this._userLogHandler && this._userLogHandler.apply(this, [this, LogLevel.ERROR].concat(args));
            this._logHandler.apply(this, [this, LogLevel.ERROR].concat(args));
        }
    }, {
        key: "logLevel",
        get: function get() {
            return this._logLevel;
        },
        set: function set(val) {
            if (!(val in LogLevel)) {
                throw new TypeError("Invalid value \"" + val + "\" assigned to `logLevel`");
            }
            this._logLevel = val;
        }
    }, {
        key: "logHandler",
        get: function get() {
            return this._logHandler;
        },
        set: function set(val) {
            if (typeof val !== 'function') {
                throw new TypeError('Value assigned to `logHandler` must be a function');
            }
            this._logHandler = val;
        }
    }, {
        key: "userLogHandler",
        get: function get() {
            return this._userLogHandler;
        },
        set: function set(val) {
            this._userLogHandler = val;
        }
    }]);

    return Logger;
}();

function setLogLevel(level) {
    instances.forEach(function (inst) {
        inst.setLogLevel(level);
    });
}
function setUserLogHandler(logCallback, options) {
    var _loop = function _loop(instance) {
        var customLogLevel = null;
        if (options && options.level) {
            customLogLevel = levelStringToEnum[options.level];
        }
        if (logCallback === null) {
            instance.userLogHandler = null;
        } else {
            instance.userLogHandler = function (instance, level) {
                for (var _len7 = arguments.length, args = Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
                    args[_key7 - 2] = arguments[_key7];
                }

                var message = args.map(function (arg) {
                    if (arg == null) {
                        return null;
                    } else if (typeof arg === 'string') {
                        return arg;
                    } else if (typeof arg === 'number' || typeof arg === 'boolean') {
                        return arg.toString();
                    } else if (arg instanceof Error) {
                        return arg.message;
                    } else {
                        try {
                            return JSON.stringify(arg);
                        } catch (ignored) {
                            return null;
                        }
                    }
                }).filter(function (arg) {
                    return arg;
                }).join(' ');
                if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) {
                    logCallback({
                        level: LogLevel[level].toLowerCase(),
                        message: message,
                        args: args,
                        type: instance.name
                    });
                }
            };
        }
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var instance = _step.value;

            _loop(instance);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

exports.LogLevel = LogLevel;
exports.Logger = Logger;
exports.setLogLevel = setLogLevel;
exports.setUserLogHandler = setUserLogHandler;
//# sourceMappingURL=index.esm2017.js.map

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/util/dist/index.esm2017.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

/**
 * @internal
 */
var deleteDB = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dbName) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt('return', new Promise(function (resolve, reject) {
                            try {
                                var request = indexedDB.deleteDatabase(dbName);
                                request.onsuccess = function () {
                                    resolve();
                                };
                                request.onerror = function (event) {
                                    var _a;
                                    reject('Error deleting indexedDB database "' + dbName + '": ' + ((_a = event.target.error) === null || _a === void 0 ? void 0 : _a.message));
                                };
                            } catch (e) {
                                reject('Error deleting indexedDB database "' + dbName + '": ' + e.message);
                            }
                        }));

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function deleteDB(_x4) {
        return _ref3.apply(this, arguments);
    };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
var CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 */
var assert = function assert(assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 */
var assertionError = function assertionError(message) {
    return new Error('Firebase Database (' + CONSTANTS.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringToByteArray$1 = function stringToByteArray$1(str) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        } else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */
var byteArrayToString = function byteArrayToString(bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [];
    var pos = 0,
        c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        } else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var _c = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = ((c1 & 7) << 18 | (_c & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            var _c2 = bytes[pos++];
            var _c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (_c2 & 63) << 6 | _c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
var base64 = {
    /**
     * Maps bytes to characters.
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeByteArray: function encodeByteArray(input, webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            var outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },

    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */
    encodeString: function encodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray$1(input), webSafe);
    },

    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */
    decodeString: function decodeString(input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },

    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */
    decodeStringToByteArray: function decodeStringToByteArray(input, webSafe) {
        this.init_();
        var charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                var outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    var outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },

    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function init_() {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 */
var base64Encode = function base64Encode(str) {
    var utf8Bytes = stringToByteArray$1(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */
var base64urlEncodeWithoutPadding = function base64urlEncodeWithoutPadding(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return base64Encode(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */
var base64Decode = function base64Decode(str) {
    try {
        return base64.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !isValidKey(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
function isValidKey(key) {
    return key !== '__proto__';
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var Deferred = function () {
    function Deferred() {
        var _this = this;

        _classCallCheck(this, Deferred);

        this.reject = function () {};
        this.resolve = function () {};
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */


    _createClass(Deferred, [{
        key: 'wrapCallback',
        value: function wrapCallback(callback) {
            var _this2 = this;

            return function (error, value) {
                if (error) {
                    _this2.reject(error);
                } else {
                    _this2.resolve(value);
                }
                if (typeof callback === 'function') {
                    // Attaching noop handler just in case developer wasn't expecting
                    // promises
                    _this2.promise.catch(function () {});
                    // Some of our callbacks don't expect a value and our own tests
                    // assert that the parameter length is 1
                    if (callback.length === 1) {
                        callback(error);
                    } else {
                        callback(error, value);
                    }
                }
            };
        }
    }]);

    return Deferred;
}();

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function createMockUserToken(token, projectId) {
    if (token.uid) {
        throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    }
    // Unsecured JWTs use "none" as the algorithm.
    var header = {
        alg: 'none',
        type: 'JWT'
    };
    var project = projectId || 'demo-project';
    var iat = token.iat || 0;
    var sub = token.sub || token.user_id;
    if (!sub) {
        throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    }
    var payload = Object.assign({
        // Set all required fields to decent defaults
        iss: 'https://securetoken.google.com/' + project, aud: project, iat: iat, exp: iat + 3600, auth_time: iat, sub: sub, user_id: sub, firebase: {
            sign_in_provider: 'custom',
            identities: {}
        } }, token);
    // Unsecured JWTs use the empty string as a signature.
    var signature = '';
    return [base64urlEncodeWithoutPadding(JSON.stringify(header)), base64urlEncodeWithoutPadding(JSON.stringify(payload)), signature].join('.');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */
function getUA() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    } else {
        return '';
    }
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */
function isMobileCordova() {
    return typeof window !== 'undefined' &&
    // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected.
 */
// Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    try {
        return Object.prototype.toString.call(global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */
function isBrowser() {
    return (typeof self === 'undefined' ? 'undefined' : _typeof(self)) === 'object' && self.self === self;
}
function isBrowserExtension() {
    var runtime = (typeof chrome === 'undefined' ? 'undefined' : _typeof(chrome)) === 'object' ? chrome.runtime : (typeof browser === 'undefined' ? 'undefined' : _typeof(browser)) === 'object' ? browser.runtime : undefined;
    return (typeof runtime === 'undefined' ? 'undefined' : _typeof(runtime)) === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */
function isReactNative() {
    return (typeof navigator === 'undefined' ? 'undefined' : _typeof(navigator)) === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */
function isElectron() {
    return getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */
function isIE() {
    var ua = getUA();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */
function isUWP() {
    return getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */
function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */
function isSafari() {
    return !isNode() && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */
function isIndexedDBAvailable() {
    return (typeof indexedDB === 'undefined' ? 'undefined' : _typeof(indexedDB)) === 'object';
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */
function validateIndexedDBOpenable() {
    return new Promise(function (resolve, reject) {
        try {
            var preExist = true;
            var DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            var request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = function () {
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) {
                    self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                }
                resolve(true);
            };
            request.onupgradeneeded = function () {
                preExist = false;
            };
            request.onerror = function () {
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */
function areCookiesEnabled() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) {
        return false;
    }
    return true;
}
/**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 */
function getGlobal() {
    if (typeof self !== 'undefined') {
        return self;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof global !== 'undefined') {
        return global;
    }
    throw new Error('Unable to locate global object.');
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if (e.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */
var ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types

var FirebaseError = function (_Error) {
    _inherits(FirebaseError, _Error);

    function FirebaseError(
    /** The error code for this error. */
    code, message,
    /** Custom data for this error. */
    customData) {
        _classCallCheck(this, FirebaseError);

        var _this3 = _possibleConstructorReturn(this, (FirebaseError.__proto__ || Object.getPrototypeOf(FirebaseError)).call(this, message));

        _this3.code = code;
        _this3.customData = customData;
        /** The custom name for all FirebaseErrors. */
        _this3.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this3, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this3, ErrorFactory.prototype.create);
        }
        return _this3;
    }

    return FirebaseError;
}(Error);

var ErrorFactory = function () {
    function ErrorFactory(service, serviceName, errors) {
        _classCallCheck(this, ErrorFactory);

        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }

    _createClass(ErrorFactory, [{
        key: 'create',
        value: function create(code) {
            var customData = (arguments.length <= 1 ? undefined : arguments[1]) || {};
            var fullCode = this.service + '/' + code;
            var template = this.errors[code];
            var message = template ? replaceTemplate(template, customData) : 'Error';
            // Service Name: Error message (service/code).
            var fullMessage = this.serviceName + ': ' + message + ' (' + fullCode + ').';
            var error = new FirebaseError(fullCode, fullMessage, customData);
            return error;
        }
    }]);

    return ErrorFactory;
}();

function replaceTemplate(template, data) {
    return template.replace(PATTERN, function (_, key) {
        var value = data[key];
        return value != null ? String(value) : '<' + key + '?>';
    });
}
var PATTERN = /\{\$([^}]+)}/g;

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var decode = function decode(token) {
    var header = {},
        claims = {},
        data = {},
        signature = '';
    try {
        var parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isValidTimestamp = function isValidTimestamp(token) {
    var claims = decode(token).claims;
    var now = Math.floor(new Date().getTime() / 1000);
    var validSince = 0,
        validUntil = 0;
    if ((typeof claims === 'undefined' ? 'undefined' : _typeof(claims)) === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        } else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        } else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var issuedAtTime = function issuedAtTime(token) {
    var claims = decode(token).claims;
    if ((typeof claims === 'undefined' ? 'undefined' : _typeof(claims)) === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isValidFormat = function isValidFormat(token) {
    var decoded = decode(token),
        claims = decoded.claims;
    return !!claims && (typeof claims === 'undefined' ? 'undefined' : _typeof(claims)) === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */
var isAdmin = function isAdmin(token) {
    var claims = decode(token).claims;
    return (typeof claims === 'undefined' ? 'undefined' : _typeof(claims)) === 'object' && claims['admin'] === true;
};

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return obj[key];
    } else {
        return undefined;
    }
}
function isEmpty(obj) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
function map(obj, fn, contextObj) {
    var res = {};
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            res[key] = fn.call(contextObj, obj[key], key, obj);
        }
    }
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */
function deepEqual(a, b) {
    if (a === b) {
        return true;
    }
    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = aKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var k = _step.value;

            if (!bKeys.includes(k)) {
                return false;
            }
            var aProp = a[k];
            var bProp = b[k];
            if (isObject(aProp) && isObject(bProp)) {
                if (!deepEqual(aProp, bProp)) {
                    return false;
                }
            } else if (aProp !== bProp) {
                return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = bKeys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _k = _step2.value;

            if (!aKeys.includes(_k)) {
                return false;
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return true;
}
function isObject(thing) {
    return thing !== null && (typeof thing === 'undefined' ? 'undefined' : _typeof(thing)) === 'object';
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */
function querystring(querystringParams) {
    var params = [];

    var _loop = function _loop(key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        } else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    };

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = Object.entries(querystringParams)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _ref = _step3.value;

            var _ref2 = _slicedToArray(_ref, 2);

            var key = _ref2[0];
            var value = _ref2[1];

            _loop(key, value);
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */
function querystringDecode(querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var _token$split = token.split('='),
                _token$split2 = _slicedToArray(_token$split, 2),
                key = _token$split2[0],
                value = _token$split2[1];

            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */
function extractQuerystring(url) {
    var queryStart = url.indexOf('?');
    if (!queryStart) {
        return '';
    }
    var fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */

var Sha1 = function () {
    function Sha1() {
        _classCallCheck(this, Sha1);

        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */
        this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */
        this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */
        this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */
        this.pad_ = [];
        /**
         * @private {number}
         */
        this.inbuf_ = 0;
        /**
         * @private {number}
         */
        this.total_ = 0;
        this.blockSize = 512 / 8;
        this.pad_[0] = 128;
        for (var i = 1; i < this.blockSize; ++i) {
            this.pad_[i] = 0;
        }
        this.reset();
    }

    _createClass(Sha1, [{
        key: 'reset',
        value: function reset() {
            this.chain_[0] = 0x67452301;
            this.chain_[1] = 0xefcdab89;
            this.chain_[2] = 0x98badcfe;
            this.chain_[3] = 0x10325476;
            this.chain_[4] = 0xc3d2e1f0;
            this.inbuf_ = 0;
            this.total_ = 0;
        }
        /**
         * Internal compress helper function.
         * @param buf Block to compress.
         * @param offset Offset of the block in the buffer.
         * @private
         */

    }, {
        key: 'compress_',
        value: function compress_(buf, offset) {
            if (!offset) {
                offset = 0;
            }
            var W = this.W_;
            // get 16 big endian words
            if (typeof buf === 'string') {
                for (var i = 0; i < 16; i++) {
                    // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                    // have a bug that turns the post-increment ++ operator into pre-increment
                    // during JIT compilation.  We have code that depends heavily on SHA-1 for
                    // correctness and which is affected by this bug, so I've removed all uses
                    // of post-increment ++ in which the result value is used.  We can revert
                    // this change once the Safari bug
                    // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                    // most clients have been updated.
                    W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
                    offset += 4;
                }
            } else {
                for (var _i = 0; _i < 16; _i++) {
                    W[_i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
                    offset += 4;
                }
            }
            // expand to 80 words
            for (var _i2 = 16; _i2 < 80; _i2++) {
                var t = W[_i2 - 3] ^ W[_i2 - 8] ^ W[_i2 - 14] ^ W[_i2 - 16];
                W[_i2] = (t << 1 | t >>> 31) & 0xffffffff;
            }
            var a = this.chain_[0];
            var b = this.chain_[1];
            var c = this.chain_[2];
            var d = this.chain_[3];
            var e = this.chain_[4];
            var f = void 0,
                k = void 0;
            // TODO(user): Try to unroll this loop to speed up the computation.
            for (var _i3 = 0; _i3 < 80; _i3++) {
                if (_i3 < 40) {
                    if (_i3 < 20) {
                        f = d ^ b & (c ^ d);
                        k = 0x5a827999;
                    } else {
                        f = b ^ c ^ d;
                        k = 0x6ed9eba1;
                    }
                } else {
                    if (_i3 < 60) {
                        f = b & c | d & (b | c);
                        k = 0x8f1bbcdc;
                    } else {
                        f = b ^ c ^ d;
                        k = 0xca62c1d6;
                    }
                }
                var _t = (a << 5 | a >>> 27) + f + e + k + W[_i3] & 0xffffffff;
                e = d;
                d = c;
                c = (b << 30 | b >>> 2) & 0xffffffff;
                b = a;
                a = _t;
            }
            this.chain_[0] = this.chain_[0] + a & 0xffffffff;
            this.chain_[1] = this.chain_[1] + b & 0xffffffff;
            this.chain_[2] = this.chain_[2] + c & 0xffffffff;
            this.chain_[3] = this.chain_[3] + d & 0xffffffff;
            this.chain_[4] = this.chain_[4] + e & 0xffffffff;
        }
    }, {
        key: 'update',
        value: function update(bytes, length) {
            // TODO(johnlenz): tighten the function signature and remove this check
            if (bytes == null) {
                return;
            }
            if (length === undefined) {
                length = bytes.length;
            }
            var lengthMinusBlock = length - this.blockSize;
            var n = 0;
            // Using local instead of member variables gives ~5% speedup on Firefox 16.
            var buf = this.buf_;
            var inbuf = this.inbuf_;
            // The outer while loop should execute at most twice.
            while (n < length) {
                // When we have no data in the block to top up, we can directly process the
                // input buffer (assuming it contains sufficient data). This gives ~25%
                // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
                // the data is provided in large chunks (or in multiples of 64 bytes).
                if (inbuf === 0) {
                    while (n <= lengthMinusBlock) {
                        this.compress_(bytes, n);
                        n += this.blockSize;
                    }
                }
                if (typeof bytes === 'string') {
                    while (n < length) {
                        buf[inbuf] = bytes.charCodeAt(n);
                        ++inbuf;
                        ++n;
                        if (inbuf === this.blockSize) {
                            this.compress_(buf);
                            inbuf = 0;
                            // Jump to the outer loop so we use the full-block optimization.
                            break;
                        }
                    }
                } else {
                    while (n < length) {
                        buf[inbuf] = bytes[n];
                        ++inbuf;
                        ++n;
                        if (inbuf === this.blockSize) {
                            this.compress_(buf);
                            inbuf = 0;
                            // Jump to the outer loop so we use the full-block optimization.
                            break;
                        }
                    }
                }
            }
            this.inbuf_ = inbuf;
            this.total_ += length;
        }
        /** @override */

    }, {
        key: 'digest',
        value: function digest() {
            var digest = [];
            var totalBits = this.total_ * 8;
            // Add pad 0x80 0x00*.
            if (this.inbuf_ < 56) {
                this.update(this.pad_, 56 - this.inbuf_);
            } else {
                this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
            }
            // Add # bits.
            for (var i = this.blockSize - 1; i >= 56; i--) {
                this.buf_[i] = totalBits & 255;
                totalBits /= 256; // Don't use bit-shifting here!
            }
            this.compress_(this.buf_);
            var n = 0;
            for (var _i4 = 0; _i4 < 5; _i4++) {
                for (var j = 24; j >= 0; j -= 8) {
                    digest[n] = this.chain_[_i4] >> j & 255;
                    ++n;
                }
            }
            return digest;
        }
    }]);

    return Sha1;
}();

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */


function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */

var ObserverProxy = function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this4 = this;

        _classCallCheck(this, ObserverProxy);

        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(function () {
            executor(_this4);
        }).catch(function (e) {
            _this4.error(e);
        });
    }

    _createClass(ObserverProxy, [{
        key: 'next',
        value: function next(value) {
            this.forEachObserver(function (observer) {
                observer.next(value);
            });
        }
    }, {
        key: 'error',
        value: function error(_error) {
            this.forEachObserver(function (observer) {
                observer.error(_error);
            });
            this.close(_error);
        }
    }, {
        key: 'complete',
        value: function complete() {
            this.forEachObserver(function (observer) {
                observer.complete();
            });
            this.close();
        }
        /**
         * Subscribe function that can be used to add an Observer to the fan-out list.
         *
         * - We require that no event is sent to a subscriber sychronously to their
         *   call to subscribe().
         */

    }, {
        key: 'subscribe',
        value: function subscribe(nextOrObserver, error, complete) {
            var _this5 = this;

            var observer = void 0;
            if (nextOrObserver === undefined && error === undefined && complete === undefined) {
                throw new Error('Missing Observer.');
            }
            // Assemble an Observer object when passed as callback functions.
            if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
                observer = nextOrObserver;
            } else {
                observer = {
                    next: nextOrObserver,
                    error: error,
                    complete: complete
                };
            }
            if (observer.next === undefined) {
                observer.next = noop;
            }
            if (observer.error === undefined) {
                observer.error = noop;
            }
            if (observer.complete === undefined) {
                observer.complete = noop;
            }
            var unsub = this.unsubscribeOne.bind(this, this.observers.length);
            // Attempt to subscribe to a terminated Observable - we
            // just respond to the Observer with the final error or complete
            // event.
            if (this.finalized) {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.task.then(function () {
                    try {
                        if (_this5.finalError) {
                            observer.error(_this5.finalError);
                        } else {
                            observer.complete();
                        }
                    } catch (e) {
                        // nothing
                    }
                    return;
                });
            }
            this.observers.push(observer);
            return unsub;
        }
        // Unsubscribe is synchronous - we guarantee that no events are sent to
        // any unsubscribed Observer.

    }, {
        key: 'unsubscribeOne',
        value: function unsubscribeOne(i) {
            if (this.observers === undefined || this.observers[i] === undefined) {
                return;
            }
            delete this.observers[i];
            this.observerCount -= 1;
            if (this.observerCount === 0 && this.onNoObservers !== undefined) {
                this.onNoObservers(this);
            }
        }
    }, {
        key: 'forEachObserver',
        value: function forEachObserver(fn) {
            if (this.finalized) {
                // Already closed by previous event....just eat the additional values.
                return;
            }
            // Since sendOne calls asynchronously - there is no chance that
            // this.observers will become undefined.
            for (var i = 0; i < this.observers.length; i++) {
                this.sendOne(i, fn);
            }
        }
        // Call the Observer via one of it's callback function. We are careful to
        // confirm that the observe has not been unsubscribed since this asynchronous
        // function had been queued.

    }, {
        key: 'sendOne',
        value: function sendOne(i, fn) {
            var _this6 = this;

            // Execute the callback asynchronously
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.task.then(function () {
                if (_this6.observers !== undefined && _this6.observers[i] !== undefined) {
                    try {
                        fn(_this6.observers[i]);
                    } catch (e) {
                        // Ignore exceptions raised in Observers or missing methods of an
                        // Observer.
                        // Log error to console. b/31404806
                        if (typeof console !== 'undefined' && console.error) {
                            console.error(e);
                        }
                    }
                }
            });
        }
    }, {
        key: 'close',
        value: function close(err) {
            var _this7 = this;

            if (this.finalized) {
                return;
            }
            this.finalized = true;
            if (err !== undefined) {
                this.finalError = err;
            }
            // Proxy is no longer needed - garbage collect references
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.task.then(function () {
                _this7.observers = undefined;
                _this7.onNoObservers = undefined;
            });
        }
    }]);

    return ObserverProxy;
}();
/** Turn synchronous function into one called asynchronously. */
// eslint-disable-next-line @typescript-eslint/ban-types


function async(fn, onError) {
    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        Promise.resolve(true).then(function () {
            fn.apply(undefined, args);
        }).catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object' || obj === null) {
        return false;
    }
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
        for (var _iterator4 = methods[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var method = _step4.value;

            if (method in obj && typeof obj[method] === 'function') {
                return true;
            }
        }
    } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
            }
        } finally {
            if (_didIteratorError4) {
                throw _iteratorError4;
            }
        }
    }

    return false;
}
function noop() {}
// do nothing


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */
var validateArgCount = function validateArgCount(fnName, minCount, maxCount, argCount) {
    var argError = void 0;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    } else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argName) {
    return fnName + ' failed: ' + argName + ' argument ';
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */
function validateNamespace(fnName, namespace, optional) {
    if (optional && !namespace) {
        return;
    }
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, 'namespace') + 'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentName,
// eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) {
        return;
    }
    if (typeof callback !== 'function') {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid function.');
    }
}
function validateContextObject(fnName, argumentName, context, optional) {
    if (optional && !context) {
        return;
    }
    if ((typeof context === 'undefined' ? 'undefined' : _typeof(context)) !== 'object' || context === null) {
        throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid context object.');
    }
}

/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
var stringToByteArray = function stringToByteArray(str) {
    var out = [];
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        } else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
var stringLength = function stringLength(str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        } else if (c < 2048) {
            p += 2;
        } else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else {
            p += 3;
        }
    }
    return p;
};

/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * The amount of milliseconds to exponentially increase.
 */
var DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */
var DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */
var MAX_VALUE_MILLIS = 4 * 60 * 60 * 1000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */
var RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */
function calculateBackoffMillis(backoffCount) {
    var intervalMillis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_INTERVAL_MILLIS;
    var backoffFactor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_BACKOFF_FACTOR;

    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    var currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    var randomWait = Math.round(
    // A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    RANDOM_FACTOR * currBaseValue * (
    // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provide English ordinal letters after a number
 */
function ordinal(i) {
    if (!Number.isFinite(i)) {
        return '' + i;
    }
    return i + indicator(i);
}
function indicator(i) {
    i = Math.abs(i);
    var cent = i % 100;
    if (cent >= 10 && cent <= 20) {
        return 'th';
    }
    var dec = i % 10;
    if (dec === 1) {
        return 'st';
    }
    if (dec === 2) {
        return 'nd';
    }
    if (dec === 3) {
        return 'rd';
    }
    return 'th';
}

/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function getModularInstance(service) {
    if (service && service._delegate) {
        return service._delegate;
    } else {
        return service;
    }
}

/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @internal
 */
function promisifyRequest(request, errorMessage) {
    return new Promise(function (resolve, reject) {
        request.onsuccess = function (event) {
            resolve(event.target.result);
        };
        request.onerror = function (event) {
            var _a;
            reject(errorMessage + ': ' + ((_a = event.target.error) === null || _a === void 0 ? void 0 : _a.message));
        };
    });
}
/**
 * @internal
 */

var DBWrapper = function () {
    function DBWrapper(_db) {
        _classCallCheck(this, DBWrapper);

        this._db = _db;
        this.objectStoreNames = this._db.objectStoreNames;
    }

    _createClass(DBWrapper, [{
        key: 'transaction',
        value: function transaction(storeNames) {
            var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'readonly';

            return new TransactionWrapper(this._db.transaction.call(this._db, storeNames, mode));
        }
    }, {
        key: 'createObjectStore',
        value: function createObjectStore(storeName, options) {
            return new ObjectStoreWrapper(this._db.createObjectStore(storeName, options));
        }
    }, {
        key: 'close',
        value: function close() {
            this._db.close();
        }
    }]);

    return DBWrapper;
}();
/**
 * @internal
 */


var TransactionWrapper = function () {
    function TransactionWrapper(_transaction) {
        var _this8 = this;

        _classCallCheck(this, TransactionWrapper);

        this._transaction = _transaction;
        this.complete = new Promise(function (resolve, reject) {
            _this8._transaction.oncomplete = function () {
                resolve();
            };
            _this8._transaction.onerror = function () {
                reject(_this8._transaction.error);
            };
            _this8._transaction.onabort = function () {
                reject(_this8._transaction.error);
            };
        });
    }

    _createClass(TransactionWrapper, [{
        key: 'objectStore',
        value: function objectStore(storeName) {
            return new ObjectStoreWrapper(this._transaction.objectStore(storeName));
        }
    }]);

    return TransactionWrapper;
}();
/**
 * @internal
 */


var ObjectStoreWrapper = function () {
    function ObjectStoreWrapper(_store) {
        _classCallCheck(this, ObjectStoreWrapper);

        this._store = _store;
    }

    _createClass(ObjectStoreWrapper, [{
        key: 'index',
        value: function index(name) {
            return new IndexWrapper(this._store.index(name));
        }
    }, {
        key: 'createIndex',
        value: function createIndex(name, keypath, options) {
            return new IndexWrapper(this._store.createIndex(name, keypath, options));
        }
    }, {
        key: 'get',
        value: function get(key) {
            var request = this._store.get(key);
            return promisifyRequest(request, 'Error reading from IndexedDB');
        }
    }, {
        key: 'put',
        value: function put(value, key) {
            var request = this._store.put(value, key);
            return promisifyRequest(request, 'Error writing to IndexedDB');
        }
    }, {
        key: 'delete',
        value: function _delete(key) {
            var request = this._store.delete(key);
            return promisifyRequest(request, 'Error deleting from IndexedDB');
        }
    }, {
        key: 'clear',
        value: function clear() {
            var request = this._store.clear();
            return promisifyRequest(request, 'Error clearing IndexedDB object store');
        }
    }]);

    return ObjectStoreWrapper;
}();
/**
 * @internal
 */


var IndexWrapper = function () {
    function IndexWrapper(_index) {
        _classCallCheck(this, IndexWrapper);

        this._index = _index;
    }

    _createClass(IndexWrapper, [{
        key: 'get',
        value: function get(key) {
            var request = this._index.get(key);
            return promisifyRequest(request, 'Error reading from IndexedDB');
        }
    }]);

    return IndexWrapper;
}();
/**
 * @internal
 */


function openDB(dbName, dbVersion, upgradeCallback) {
    return new Promise(function (resolve, reject) {
        try {
            var request = indexedDB.open(dbName, dbVersion);
            request.onsuccess = function (event) {
                resolve(new DBWrapper(event.target.result));
            };
            request.onerror = function (event) {
                var _a;
                reject('Error opening indexedDB: ' + ((_a = event.target.error) === null || _a === void 0 ? void 0 : _a.message));
            };
            request.onupgradeneeded = function (event) {
                upgradeCallback(new DBWrapper(request.result), event.oldVersion, event.newVersion, new TransactionWrapper(request.transaction));
            };
        } catch (e) {
            reject('Error opening indexedDB: ' + e.message);
        }
    });
}exports.CONSTANTS = CONSTANTS;
exports.DBWrapper = DBWrapper;
exports.Deferred = Deferred;
exports.ErrorFactory = ErrorFactory;
exports.FirebaseError = FirebaseError;
exports.MAX_VALUE_MILLIS = MAX_VALUE_MILLIS;
exports.RANDOM_FACTOR = RANDOM_FACTOR;
exports.Sha1 = Sha1;
exports.areCookiesEnabled = areCookiesEnabled;
exports.assert = assert;
exports.assertionError = assertionError;
exports.async = async;
exports.base64 = base64;
exports.base64Decode = base64Decode;
exports.base64Encode = base64Encode;
exports.base64urlEncodeWithoutPadding = base64urlEncodeWithoutPadding;
exports.calculateBackoffMillis = calculateBackoffMillis;
exports.contains = contains;
exports.createMockUserToken = createMockUserToken;
exports.createSubscribe = createSubscribe;
exports.decode = decode;
exports.deepCopy = deepCopy;
exports.deepEqual = deepEqual;
exports.deepExtend = deepExtend;
exports.deleteDB = deleteDB;
exports.errorPrefix = errorPrefix;
exports.extractQuerystring = extractQuerystring;
exports.getGlobal = getGlobal;
exports.getModularInstance = getModularInstance;
exports.getUA = getUA;
exports.isAdmin = isAdmin;
exports.isBrowser = isBrowser;
exports.isBrowserExtension = isBrowserExtension;
exports.isElectron = isElectron;
exports.isEmpty = isEmpty;
exports.isIE = isIE;
exports.isIndexedDBAvailable = isIndexedDBAvailable;
exports.isMobileCordova = isMobileCordova;
exports.isNode = isNode;
exports.isNodeSdk = isNodeSdk;
exports.isReactNative = isReactNative;
exports.isSafari = isSafari;
exports.isUWP = isUWP;
exports.isValidFormat = isValidFormat;
exports.isValidTimestamp = isValidTimestamp;
exports.issuedAtTime = issuedAtTime;
exports.jsonEval = jsonEval;
exports.map = map;
exports.openDB = openDB;
exports.ordinal = ordinal;
exports.querystring = querystring;
exports.querystringDecode = querystringDecode;
exports.safeGet = safeGet;
exports.stringLength = stringLength;
exports.stringToByteArray = stringToByteArray;
exports.stringify = stringify;
exports.validateArgCount = validateArgCount;
exports.validateCallback = validateCallback;
exports.validateContextObject = validateContextObject;
exports.validateIndexedDBOpenable = validateIndexedDBOpenable;
exports.validateNamespace = validateNamespace;
//# sourceMappingURL=index.esm2017.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/debug/src/browser.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */

exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = function () {
	var warned = false;

	return function () {
		if (!warned) {
			warned = true;
			console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
		}
	};
}();

/**
 * Colors.
 */

exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

// eslint-disable-next-line complexity
function useColors() {
	// NB: In an Electron preload script, document will be defined but not fully
	// initialized. Since we know we're in Chrome, we'll just detect this case
	// explicitly
	if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
		return true;
	}

	// Internet Explorer and Edge do not support colors.
	if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
		return false;
	}

	// Is webkit? http://stackoverflow.com/a/16459606/376773
	// document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance ||
	// Is firebug? http://stackoverflow.com/a/398120/376773
	typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) ||
	// Is firefox >= v31?
	// https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 ||
	// Double check webkit in userAgent just in case we are in a worker
	typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
	args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);

	if (!this.useColors) {
		return;
	}

	var c = 'color: ' + this.color;
	args.splice(1, 0, c, 'color: inherit');

	// The final "%c" is somewhat tricky, because there could be other
	// arguments passed either before or after the %c, so we need to
	// figure out the correct index to insert the CSS into
	var index = 0;
	var lastC = 0;
	args[0].replace(/%[a-zA-Z%]/g, function (match) {
		if (match === '%%') {
			return;
		}
		index++;
		if (match === '%c') {
			// We only are interested in the *last* %c
			// (the user may have provided their own)
			lastC = index;
		}
	});

	args.splice(lastC, 0, c);
}

/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */
exports.log = console.debug || console.log || function () {};

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */
function save(namespaces) {
	try {
		if (namespaces) {
			exports.storage.setItem('debug', namespaces);
		} else {
			exports.storage.removeItem('debug');
		}
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */
function load() {
	var r = void 0;
	try {
		r = exports.storage.getItem('debug');
	} catch (error) {}
	// Swallow
	// XXX (@Qix-) should we be logging these?


	// If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	if (!r && typeof process !== 'undefined' && 'env' in process) {
		r = process.env.DEBUG;
	}

	return r;
}

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
	try {
		// TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
		// The Browser also has localStorage in the global context.
		return localStorage;
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

module.exports = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/debug/src/common.js")(exports);

var formatters = module.exports.formatters;

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
	try {
		return JSON.stringify(v);
	} catch (error) {
		return '[UnexpectedJSONParseError]: ' + error.message;
	}
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/process/browser.js")))

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/debug/src/common.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */

function setup(env) {
	createDebug.debug = createDebug;
	createDebug.default = createDebug;
	createDebug.coerce = coerce;
	createDebug.disable = disable;
	createDebug.enable = enable;
	createDebug.enabled = enabled;
	createDebug.humanize = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/ms/index.js");
	createDebug.destroy = destroy;

	Object.keys(env).forEach(function (key) {
		createDebug[key] = env[key];
	});

	/**
 * The currently active debug mode names, and names to skip.
 */

	createDebug.names = [];
	createDebug.skips = [];

	/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */
	createDebug.formatters = {};

	/**
 * Selects a color for a debug namespace
 * @param {String} namespace The namespace string for the debug instance to be colored
 * @return {Number|String} An ANSI color code for the given namespace
 * @api private
 */
	function selectColor(namespace) {
		var hash = 0;

		for (var i = 0; i < namespace.length; i++) {
			hash = (hash << 5) - hash + namespace.charCodeAt(i);
			hash |= 0; // Convert to 32bit integer
		}

		return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
	}
	createDebug.selectColor = selectColor;

	/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */
	function createDebug(namespace) {
		var prevTime = void 0;
		var enableOverride = null;
		var namespacesCache = void 0;
		var enabledCache = void 0;

		function debug() {
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			// Disabled?
			if (!debug.enabled) {
				return;
			}

			var self = debug;

			// Set `diff` timestamp
			var curr = Number(new Date());
			var ms = curr - (prevTime || curr);
			self.diff = ms;
			self.prev = prevTime;
			self.curr = curr;
			prevTime = curr;

			args[0] = createDebug.coerce(args[0]);

			if (typeof args[0] !== 'string') {
				// Anything else let's inspect with %O
				args.unshift('%O');
			}

			// Apply any `formatters` transformations
			var index = 0;
			args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
				// If we encounter an escaped % then don't increase the array index
				if (match === '%%') {
					return '%';
				}
				index++;
				var formatter = createDebug.formatters[format];
				if (typeof formatter === 'function') {
					var val = args[index];
					match = formatter.call(self, val);

					// Now we need to remove `args[index]` since it's inlined in the `format`
					args.splice(index, 1);
					index--;
				}
				return match;
			});

			// Apply env-specific formatting (colors, etc.)
			createDebug.formatArgs.call(self, args);

			var logFn = self.log || createDebug.log;
			logFn.apply(self, args);
		}

		debug.namespace = namespace;
		debug.useColors = createDebug.useColors();
		debug.color = createDebug.selectColor(namespace);
		debug.extend = extend;
		debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.

		Object.defineProperty(debug, 'enabled', {
			enumerable: true,
			configurable: false,
			get: function get() {
				if (enableOverride !== null) {
					return enableOverride;
				}
				if (namespacesCache !== createDebug.namespaces) {
					namespacesCache = createDebug.namespaces;
					enabledCache = createDebug.enabled(namespace);
				}

				return enabledCache;
			},
			set: function set(v) {
				enableOverride = v;
			}
		});

		// Env-specific initialization logic for debug instances
		if (typeof createDebug.init === 'function') {
			createDebug.init(debug);
		}

		return debug;
	}

	function extend(namespace, delimiter) {
		var newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
		newDebug.log = this.log;
		return newDebug;
	}

	/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */
	function enable(namespaces) {
		createDebug.save(namespaces);
		createDebug.namespaces = namespaces;

		createDebug.names = [];
		createDebug.skips = [];

		var i = void 0;
		var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
		var len = split.length;

		for (i = 0; i < len; i++) {
			if (!split[i]) {
				// ignore empty strings
				continue;
			}

			namespaces = split[i].replace(/\*/g, '.*?');

			if (namespaces[0] === '-') {
				createDebug.skips.push(new RegExp('^' + namespaces.slice(1) + '$'));
			} else {
				createDebug.names.push(new RegExp('^' + namespaces + '$'));
			}
		}
	}

	/**
 * Disable debug output.
 *
 * @return {String} namespaces
 * @api public
 */
	function disable() {
		var namespaces = [].concat(_toConsumableArray(createDebug.names.map(toNamespace)), _toConsumableArray(createDebug.skips.map(toNamespace).map(function (namespace) {
			return '-' + namespace;
		}))).join(',');
		createDebug.enable('');
		return namespaces;
	}

	/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */
	function enabled(name) {
		if (name[name.length - 1] === '*') {
			return true;
		}

		var i = void 0;
		var len = void 0;

		for (i = 0, len = createDebug.skips.length; i < len; i++) {
			if (createDebug.skips[i].test(name)) {
				return false;
			}
		}

		for (i = 0, len = createDebug.names.length; i < len; i++) {
			if (createDebug.names[i].test(name)) {
				return true;
			}
		}

		return false;
	}

	/**
 * Convert regexp to namespace
 *
 * @param {RegExp} regxep
 * @return {String} namespace
 * @api private
 */
	function toNamespace(regexp) {
		return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, '*');
	}

	/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */
	function coerce(val) {
		if (val instanceof Error) {
			return val.stack || val.message;
		}
		return val;
	}

	/**
 * XXX DO NOT USE. This is a temporary stub function.
 * XXX It WILL be removed in the next major release.
 */
	function destroy() {
		console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
	}

	createDebug.enable(createDebug.load());

	return createDebug;
}

module.exports = setup;

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/firebase/analytics/dist/index.esm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _analytics = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/analytics/dist/esm/index.esm2017.js");

Object.keys(_analytics).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _analytics[key];
    }
  });
});

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/firebase/app/dist/index.esm.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _app = __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/@firebase/app/dist/esm/index.esm2017.js");

Object.keys(_app).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _app[key];
    }
  });
});


var name = "firebase";
var version = "9.6.11";

/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(0, _app.registerVersion)(name, version, 'app');
//# sourceMappingURL=index.esm.js.map

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/ms/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function (val, options) {
  options = options || {};
  var type = typeof val === 'undefined' ? 'undefined' : _typeof(val);
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

/***/ }),

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/node_modules/regenerator-runtime/runtime.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction ||
    // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  exports.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function (arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function (error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
      // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
      // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);

    return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function () {
    return this;
  });

  define(Gp, "toString", function () {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function (object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function stop() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;
}(
// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
( false ? "undefined" : _typeof(module)) === "object" ? module.exports : {});

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if ((typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "/tool/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--7-0!/tool/node_modules/css-loader/index.js??ref--7-1!/tool/node_modules/postcss-loader/lib/index.js??ref--7-2!/tool/node_modules/sass-loader/lib/loader.js??ref--7-3!/tool/project/client/src/core/index.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/tool/project/client/src/core/vendor/index.js":
/***/ (function(module, exports) {



/***/ }),

/***/ "external \"ally\"":
/***/ (function(module, exports) {

module.exports = ally;

/***/ }),

/***/ "external \"lottie\"":
/***/ (function(module, exports) {

module.exports = lottie;

/***/ }),

/***/ "multi /tool/project/client/src/core/index.js /tool/project/client/src/core/index.scss":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("/tool/node_modules/babel-loader/lib/index.js??ref--5-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/index.js");
module.exports = __webpack_require__("/tool/node_modules/extract-text-webpack-plugin/dist/loader.js??ref--7-0!/tool/node_modules/css-loader/index.js??ref--7-1!/tool/node_modules/postcss-loader/lib/index.js??ref--7-2!/tool/node_modules/sass-loader/lib/loader.js??ref--7-3!/tool/project/client/src/core/index.scss");


/***/ })

},["multi /tool/project/client/src/core/index.js /tool/project/client/src/core/index.scss"]);


// WEBPACK FOOTER //
// scripts/core--98b170839f85ed097735.js